import { Addon, Plan } from "@penji/shared/data-access";

export const environment = {
  back_end_url: 'https://penji.co/',
  firebase: {
    apiKey: 'AIzaSyCjFKj-5lTNn40D9nwN3LE47ZXSdjg6pSw',
    authDomain: 'penji30-455d7.firebaseapp.com',
    databaseURL: 'https://penji30-455d7.firebaseio.com',
    projectId: 'penji30-455d7',
    storageBucket: 'penji30-455d7.appspot.com',
    messagingSenderId: '898355351636',
    appId: '1:898355351636:web:3f7bfabfb4827d0f',
    measurementId: "G-K3KE6D1MV1"
  },
  useEmulators: false,
  production: true,
  stripe_publish_key: 'pk_live_PtIii5ZcvJiCqh3a5QdV8X7L',
  marketplace_front_end_url: 'https://marketplace.penji.co/',
  marketplace_back_end_url: 'https://marketplace-backend.penji.co/',
  api_link: 'https://penji-api-prod-cc47cmrmtq-uc.a.run.app/api',
  api_upload_file_url: 'https://api-upload-file-prod-cc47cmrmtq-uc.a.run.app/api',
  marketplace_checkout_api_url: 'https://marketplace-checkout-api-prod-cc47cmrmtq-uc.a.run.app/api',
  api_heroku: 'https://penjiapi.herokuapp.com:443/api',

  //api link k8s
  api_algolia: 'https://api.penji.co/api-algolia',
  api_checkout: 'https://api.penji.co/api-checkout',
};
export const list_all_plan: { [key: string]: Plan } = {
  pro_monthly: {
    plan_id: 'monthly_plan_pro_2023',
    plan_name: 'Pro',
    plan_base: 499,
    plan_save: 0,
    plan_package: 'pro',
    plan_duration: 'monthly',
    plan_duration_short: 'm',
    plan_duration_month: 1,
    plan_description: [
      '120+ graphic design services',
      'Logos & branding',
      'Custom illustrations',
      '2 brands',
      '5GB storage',
      '1-2 day turnaround',
      '30-day money back guarantee'
    ],
  },
  pro_quarterly: {
    plan_id: 'quarterly_plan_pro_2023',
    plan_name: 'Pro',
    plan_base: 499 * 3 * 0.85,
    plan_save: 499 * 3 * 0.15,
    plan_package: 'pro',
    plan_duration: 'quarterly',
    plan_duration_short: '3m',
    plan_duration_month: 3,
    plan_description: [
      '120+ graphic design services',
      'Logos & branding',
      'Custom illustrations',
      '2 brands',
      '5GB storage',
      '1-2 day turnaround',
      '30-day money back guarantee'
    ],
  },
  pro_yearly: {
    plan_id: 'yearly_plan_pro_2023',
    plan_name: 'Pro',
    plan_base: 499 * 12 * 0.75,
    plan_save: 499 * 12 * 0.25,
    plan_package: 'pro',
    plan_duration: 'yearly',
    plan_duration_short: 'y',
    plan_duration_month: 12,
    plan_description: [
      '120+ graphic design services',
      'Logos & branding',
      'Custom illustrations',
      '2 brands',
      '5GB storage',
      '1-2 day turnaround',
      '30-day money back guarantee'
    ],
  },
  team_monthly: {
    plan_id: 'monthly_plan_team_2023',
    plan_name: 'Team',
    plan_base: 997,
    plan_save: 0,
    plan_package: 'team',
    plan_duration: 'monthly',
    plan_duration_short: 'm',
    plan_duration_month: 1,
    plan_description: [
      'Everything in Pro',
      '2 designers',
      'Presentation design',
      'Unlimited brands',
      'Unlimited storage',
      'Project manager',
      '30-day money back guarantee'
    ],
  },
  team_quarterly: {
    plan_id: 'quarterly_plan_team_2023',
    plan_name: 'Team',
    plan_base: 997 * 3 * 0.85,
    plan_save: 997 * 3 * 0.15,
    plan_package: 'team',
    plan_duration: 'quarterly',
    plan_duration_short: '3m',
    plan_duration_month: 3,
    plan_description: [
      'Everything in Pro',
      '2 designers',
      'Presentation design',
      'Unlimited brands',
      'Unlimited storage',
      'Project manager',
      '30-day money back guarantee'
    ],
  },
  team_yearly: {
    plan_id: 'yearly_plan_team_2023',
    plan_name: 'Team',
    plan_base: 997 * 12 * 0.75,
    plan_save: 997 * 12 * 0.25,
    plan_package: 'team',
    plan_duration: 'yearly',
    plan_duration_short: 'y',
    plan_duration_month: 12,
    plan_description: [
      'Everything in Pro',
      '2 designers',
      'Presentation design',
      'Unlimited brands',
      'Unlimited storage',
      'Project manager',
      '30-day money back guarantee'
    ],
  },
  agency_monthly: {
    plan_id: 'monthly_plan_agency_2023_v1',
    plan_name: 'Agency',
    plan_base: 1995,
    plan_save: 0,
    plan_package: 'agency',
    plan_duration: 'monthly',
    plan_duration_short: 'm',
    plan_duration_month: 1,
    plan_description: [
      'Everything in Team',
      '3 Designers',
      'Project manager',
      'Priority support',
      '30-day money back guarantee'
    ],
  },
  agency_quarterly: {
    plan_id: 'quarterly_plan_agency_2023_v1',
    plan_name: 'Agency',
    plan_base: 1995 * 3 * 0.85,
    plan_save: 1995 * 3 * 0.15,
    plan_package: 'agency',
    plan_duration: 'quarterly',
    plan_duration_short: '3m',
    plan_duration_month: 3,
    plan_description: [
      'Everything in Team',
      '3 Designers',
      'Project manager',
      'Priority support',
      '30-day money back guarantee'
    ],
  },
  agency_yearly: {
    plan_id: 'yearly_plan_agency_2023_v1',
    plan_name: 'Agency',
    plan_base: 1995 * 12 * 0.75,
    plan_save: 1995 * 12 * 0.25,
    plan_package: 'agency',
    plan_duration: 'yearly',
    plan_duration_short: 'y',
    plan_duration_month: 12,
    plan_description: [
      'Everything in Team',
      '3 Designers',
      'Project manager',
      'Priority support',
      '30-day money back guarantee'
    ],
  },
};
export const list_all_addon: Array<Addon> = [
  {
    addon_id: 'service_illustrations',
    type: 'service', // dùng để if/else show cho step nào: addon, designer manage, night time...
    title: 'Illustrations',
    image_url: '../assets/images/illustrations.svg',
    description: 'Make your brand truly unique with custom illustrations that tell your story.',
    included_plan: [
      'monthly_plan_pro_2023',
      'quarterly_plan_pro_2023',
      'yearly_plan_pro_2023',
      'monthly_plan_team_2023',
      'quarterly_plan_team_2023',
      'yearly_plan_team_2023',
      'monthly_plan_agency_2023_v1',
      'quarterly_plan_agency_2023_v1',
      'yearly_plan_agency_2023_v1',
    ], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
    none_display_plan: [],
    text_excluded_plan: '',
    options: {
      'monthly': {
        addon_id: 'monthly_addon_illustrations_2023',
        price: 299,
      },
      'quarterly': {
        addon_id: 'quarterly_addon_illustrations_2023',
        price: 897
      },
      'yearly': {
        addon_id: 'yearly_addon_illustrations_2023',
        price: 3588
      }
    },
    step: 1
  },
  {
    addon_id: 'service_web_design',
    type: 'service', // dùng để if/else show cho step nào: addon, designer manage, night time...
    title: 'Web design',
    image_url: '../assets/images/web-design.svg',
    description: 'Let our expert designers create stunning, responsive websites that enhance user experience and drive conversions.',
    included_plan: [
      'monthly_plan_team_2023',
      'quarterly_plan_team_2023',
      'yearly_plan_team_2023',
      'monthly_plan_agency_2023_v1',
      'quarterly_plan_agency_2023_v1',
      'yearly_plan_agency_2023_v1',
    ], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
    none_display_plan: [],
    text_excluded_plan: '',
    options: {
      'monthly': {
        addon_id: 'monthly_addon_web_design_2023',
        price: 499,
      },
      'quarterly': {
        addon_id: 'quarterly_addon_web_design_2023',
        price: 1497
      },
      'yearly': {
        addon_id: 'yearly_addon_web_design_2023',
        price: 5988
      }
    },
    step: 1
  },
  {
    addon_id: 'service_app_design',
    type: 'service', // dùng để if/else show cho step nào: addon, designer manage, night time...
    title: 'App design',
    image_url: '../assets/images/app-design.svg',
    description: 'Let our app designers craft intuitive, seamless, visually appealing apps for engagement or entertainment.',
    included_plan: [], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
    none_display_plan: [],
    text_excluded_plan: '',
    options: {
      'monthly': {
        addon_id: 'monthly_addon_app_design_2023',
        price: 499,
      },
      'quarterly': {
        addon_id: 'quarterly_addon_app_design_2023',
        price: 1497
      },
      'yearly': {
        addon_id: 'yearly_addon_app_design_2023',
        price: 5988
      }
    },
    step: 1
  },
  {
    addon_id: 'service_presentation_design',
    type: 'service', // dùng để if/else show cho step nào: addon, designer manage, night time...
    title: 'Presentation design',
    image_url: '../assets/images/presentation-design.svg',
    description: 'Be unforgettable. Let our presentation designers ignite your slides and make it captivating and memorable.',
    included_plan: [
      'monthly_plan_team_2023',
      'quarterly_plan_team_2023',
      'yearly_plan_team_2023',
      'monthly_plan_agency_2023_v1',
      'quarterly_plan_agency_2023_v1',
      'yearly_plan_agency_2023_v1',
    ], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
    none_display_plan: [],
    text_excluded_plan: '',
    options: {
      'monthly': {
        addon_id: 'monthly_addon_presentation_design_2023',
        price: 249,
      },
      'quarterly': {
        addon_id: 'quarterly_addon_presentation_design_2023',
        price: 747
      },
      'yearly': {
        addon_id: 'yearly_addon_presentation_design_2023',
        price: 2988
      }
    },
    step: 1
  },
  {
    addon_id: 'service_motion_graphics',
    type: 'service', // dùng để if/else show cho step nào: addon, designer manage, night time...
    title: 'Motion graphics',
    image_url: '../assets/images/motion-graphics.gif',
    description: 'Your ads /marketing materials deserve a major upgrade. Have our animators create jaw-dropping  animations designed to break records.',
    included_plan: [], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
    none_display_plan: [],
    text_excluded_plan: '',
    options: {
      'monthly': {
        addon_id: 'monthly_addon_motion_graphics_2023',
        price: 499,
      },
      'quarterly': {
        addon_id: 'quarterly_addon_motion_graphics_2023',
        price: 1497
      },
      'yearly': {
        addon_id: 'yearly_addon_motion_graphics_2023',
        price: 5988
      }
    },
    step: 1
  },
  {
    addon_id: 'design_manager_none',
    type: 'design_manager', // dùng để if/else show cho step nào: addon, designer manage, night time...
    title: 'Auto assign designer',
    image_url: '../assets/images/none.svg',
    description: 'I don’t mind working directly with my assigned designer(s).',
    included_plan: [
      'monthly_plan_pro_2023',
      'quarterly_plan_pro_2023',
      'yearly_plan_pro_2023',
      'monthly_plan_team_2023',
      'quarterly_plan_team_2023',
      'yearly_plan_team_2023',
      'monthly_plan_agency_2023_v1',
      'quarterly_plan_agency_2023_v1',
      'yearly_plan_agency_2023_v1',
    ], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
    none_display_plan: [
      'monthly_plan_team_2023',
      'quarterly_plan_team_2023',
      'yearly_plan_team_2023',
      'monthly_plan_agency_2023_v1',
      'quarterly_plan_agency_2023_v1',
      'yearly_plan_agency_2023_v1',
    ],
    text_excluded_plan: '',
    options: {
      'monthly': {
        addon_id: 'monthly_addon_design_manager_2023',
        price: 0,
      },
      'quarterly': {
        addon_id: 'quarterly_addon_design_manager_2023',
        price: 0
      },
      'yearly': {
        addon_id: 'yearly_addon_design_manager_2023',
        price: 0
      }
    },
    step: 2,
  },
  {
    addon_id: 'design_manager_project_manager',
    type: 'design_manager', // dùng để if/else show cho step nào: addon, designer manage, night time...
    title: 'Project manager',
    image_url: '../assets/images/project-manager.svg',
    description: 'I need a Project Manager to help quality check and ensure my designs are consistent and on-brand.',
    included_plan: [
      'monthly_plan_team_2023',
      'quarterly_plan_team_2023',
      'yearly_plan_team_2023',
      'monthly_plan_agency_2023_v1',
      'quarterly_plan_agency_2023_v1',
      'yearly_plan_agency_2023_v1',
    ], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
    none_display_plan: [],
    text_excluded_plan: '',
    options: {
      'monthly': {
        addon_id: 'monthly_addon_project_manager_2023',
        price: 249,
      },
      'quarterly': {
        addon_id: 'quarterly_addon_project_manager_2023',
        price: 747
      },
      'yearly': {
        addon_id: 'yearly_addon_project_manager_2023',
        price: 2988
      }
    },
    step: 2,
  },
  {
    addon_id: 'design_manager_art_directors',
    type: 'design_manager', // dùng để if/else show cho step nào: addon, designer manage, night time...
    title: 'Art directors',
    image_url: '../assets/images/art-directors.svg',
    description: 'I need an Art Director to work with me 1-on-1, get on Video calls, advise/brainstorm ideas, and help bring those ideas to life.',
    included_plan: [], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
    none_display_plan: [],
    text_excluded_plan: '',
    options: {
      'monthly': {
        addon_id: 'monthly_addon_art_directors_2023',
        price: 499,
      },
      'quarterly': {
        addon_id: 'quarterly_addon_art_directors_2023',
        price: 1497
      },
      'yearly': {
        addon_id: 'yearly_addon_art_directors_2023',
        price: 5988
      }
    },
    step: 2,
  },
  {
    addon_id: 'talent_preference_pro_designers',
    type: 'talent_preference', // dùng để if/else show cho step nào: addon, designer manage, night time...
    title: 'Pro designers',
    image_url: '../assets/images/pro-designers.svg',
    description: 'Top 2% of creatives in the world for your general design needs.',
    included_plan: [
      'monthly_plan_pro_2023',
      'quarterly_plan_pro_2023',
      'yearly_plan_pro_2023',
      'monthly_plan_team_2023',
      'quarterly_plan_team_2023',
      'yearly_plan_team_2023',
      'monthly_plan_agency_2023_v1',
      'quarterly_plan_agency_2023_v1',
      'yearly_plan_agency_2023_v1',
    ], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
    none_display_plan: [],
    text_excluded_plan: '',
    options: {
      'monthly': {
        addon_id: 'monthly_addon_pro_designer_2023',
        price: 0,
      },
      'quarterly': {
        addon_id: 'quarterly_addon_pro_designer_2023',
        price: 0
      },
      'yearly': {
        addon_id: 'yearly_addon_pro_designer_2023',
        price: 0
      }
    },
    step: 2,
  },
  {
    addon_id: 'talent_preference_expert_designers',
    type: 'talent_preference', // dùng để if/else show cho step nào: addon, designer manage, night time...
    title: 'Expert designers',
    image_url: '../assets/images/expert-designers.svg',
    description: 'Need designers who are experts in YOUR industry?',
    included_plan: [], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
    none_display_plan: [],
    text_excluded_plan: '',
    options: {
      'monthly': {
        addon_id: 'monthly_addon_expert_designers_2023',
        price: 499,
        discount_price: 129,
        discount_text: 'Today only!',
      },
      'quarterly': {
        addon_id: 'quarterly_addon_expert_designers_2023',
        price: 387
      },
      'yearly': {
        addon_id: 'yearly_addon_expert_designers_2023',
        price: 1548
      }
    },
    step: 2,
  },
  {
    addon_id: 'talent_preference_certified_designers',
    type: 'talent_preference', // dùng để if/else show cho step nào: addon, designer manage, night time...
    title: 'Certified designers',
    image_url: '../assets/images/certified-designers.svg',
    description: 'Top 1%. When you can’t settle for anything less than the best.',
    included_plan: [], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
    none_display_plan: [],
    text_excluded_plan: '',
    options: {
      'monthly': {
        addon_id: 'monthly_addon_certified_designers_2023',
        price: 999,
      },
      'quarterly': {
        addon_id: 'quarterly_addon_certified_designers_2023',
        price: 2997
      },
      'yearly': {
        addon_id: 'yearly_addon_certified_designers_2023',
        price: 11988
      }
    },
    step: 2,
  },
  {
    addon_id: 'time_zone_nighttime',
    type: 'time_zone', // dùng để if/else show cho step nào: addon, designer manage, night time...
    title: 'U.S. Nighttime',
    image_url: '../assets/images/nighttime.svg',
    description: 'We’ll assign designers who will work Evening EST hours.',
    included_plan: [
      'monthly_plan_pro_2023',
      'quarterly_plan_pro_2023',
      'yearly_plan_pro_2023',
      'monthly_plan_team_2023',
      'quarterly_plan_team_2023',
      'yearly_plan_team_2023',
      'monthly_plan_agency_2023_v1',
      'quarterly_plan_agency_2023_v1',
      'yearly_plan_agency_2023_v1',
    ], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
    none_display_plan: [],
    text_excluded_plan: '',
    options: {
      'monthly': {
        addon_id: 'monthly_addon_us_night_time_2023',
        price: 0,
      },
      'quarterly': {
        addon_id: 'quarterly_addon_us_night_time_2023',
        price: 0
      },
      'yearly': {
        addon_id: 'yearly_addon_us_night_time_2023',
        price: 0
      }
    },
    step: 2,
  },
  {
    addon_id: 'time_zone_daytime',
    type: 'time_zone', // dùng để if/else show cho step nào: addon, designer manage, night time...
    title: 'U.S. Daytime',
    image_url: '../assets/images/daytime.svg',
    description: 'We’ll assign designers working Daytime EST hours.',
    included_plan: [], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
    none_display_plan: [],
    text_excluded_plan: '',
    options: {
      'monthly': {
        addon_id: 'monthly_addon_us_daytime_2023',
        price: 499,
      },
      'quarterly': {
        addon_id: 'quarterly_addon_us_daytime_2023',
        price: 1497
      },
      'yearly': {
        addon_id: 'yearly_addon_us_daytime_2023',
        price: 5988
      }
    },
    step: 2,
  },
  {
    addon_id: 'no_of_designer_1designer',
    type: 'no_of_designer', // dùng để if/else show cho step nào: addon, designer manage, night time...
    title: '1 project at a time',
    image_url: '../assets/images/1designer.svg',
    description: '',
    included_plan: [
      'monthly_plan_pro_2023',
      'quarterly_plan_pro_2023',
      'yearly_plan_pro_2023',
      // 'monthly_plan_team_2023',
      // 'quarterly_plan_team_2023',
      // 'yearly_plan_team_2023',
      // 'monthly_plan_agency_2023_v1',
      // 'quarterly_plan_agency_2023_v1',
      // 'yearly_plan_agency_2023_v1',
    ], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
    none_display_plan: [
      'monthly_plan_team_2023',
      'quarterly_plan_team_2023',
      'yearly_plan_team_2023',
      'monthly_plan_agency_2023_v1',
      'quarterly_plan_agency_2023_v1',
      'yearly_plan_agency_2023_v1',
    ],
    text_excluded_plan: '',
    options: {
      'monthly': {
        addon_id: 'monthly_addon_1_designer_2023',
        price: 0,
      },
      'quarterly': {
        addon_id: 'quarterly_addon_1_designer_2023',
        price: 0
      },
      'yearly': {
        addon_id: 'yearly_addon_1_designer_2023',
        price: 0
      }
    },
    step: 2,
  },
  {
    addon_id: 'no_of_designer_2designers',
    type: 'no_of_designer', // dùng để if/else show cho step nào: addon, designer manage, night time...
    title: '2 projects at a time',
    image_url: '../assets/images/2designers.svg',
    description: '',
    included_plan: [
      'monthly_plan_team_2023',
      'quarterly_plan_team_2023',
      'yearly_plan_team_2023',
      // 'monthly_plan_agency_2023_v1',
      // 'quarterly_plan_agency_2023_v1',
      // 'yearly_plan_agency_2023_v1',
    ], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
    none_display_plan: [
      'monthly_plan_agency_2023_v1',
      'quarterly_plan_agency_2023_v1',
      'yearly_plan_agency_2023_v1',
    ],
    text_excluded_plan: '',
    options: {
      'monthly': {
        addon_id: 'monthly_addon_2_designer_2023',
        price: 499,
      },
      'quarterly': {
        addon_id: 'quarterly_addon_2_designer_2023',
        price: 1497
      },
      'yearly': {
        addon_id: 'yearly_addon_2_designer_2023',
        price: 5988
      }
    },
    step: 2,
  },
  {
    addon_id: 'no_of_designer_3designers',
    type: 'no_of_designer', // dùng để if/else show cho step nào: addon, designer manage, night time...
    title: '3 projects at a time',
    image_url: '../assets/images/3designers.svg',
    description: '',
    included_plan: [
      'monthly_plan_agency_2023_v1',
      'quarterly_plan_agency_2023_v1',
      'yearly_plan_agency_2023_v1',
    ], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
    none_display_plan: [],
    text_excluded_plan: '',
    options: {
      'monthly': {
        addon_id: 'monthly_addon_3_designer_2023',
        price: 998,
      },
      'quarterly': {
        addon_id: 'quarterly_addon_3_designer_2023',
        price: 2994
      },
      'yearly': {
        addon_id: 'yearly_addon_3_designer_2023',
        price: 11976
      }
    },
    step: 2,
  },
  // {
  //   addon_id: 'platform_penji',
  //   type: 'platform', // dùng để if/else show cho step nào: addon, designer manage, night time...
  //   title: 'No thanks, only Penji',
  //   image_url: '../assets/images/platform-penji.svg',
  //   description: 'All projects will be solely in Penji platform.',
  //   included_plan: [
  //       'monthly_plan_pro_2023',
  //       'quarterly_plan_pro_2023',
  //       'yearly_plan_pro_2023',
  //       'monthly_plan_team_2023',
  //       'quarterly_plan_team_2023',
  //       'yearly_plan_team_2023',
  //       'monthly_plan_agency_2023_v1',
  //       'quarterly_plan_agency_2023_v1',
  //       'yearly_plan_agency_2023_v1',
  //   ], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
  //   text_excluded_plan: '',
  //   options: {
  //     'monthly': {
  //       addon_id: 'monthly_addon_platform_2023',
  //       price: 0,
  //     },
  //     'quarterly': {
  //       addon_id: 'quarterly_addon_platform_2023',
  //       price: 0
  //     },
  //     'yearly': {
  //       addon_id: 'yearly_addon_platform_2023',
  //       price: 0
  //     }
  //   },
  //   step: 2,
  // },
  // {
  //   addon_id: 'platform_canva',
  //   type: 'platform', // dùng để if/else show cho step nào: addon, designer manage, night time...
  //   title: 'Canva',
  //   image_url: '../assets/images/platform-canva.svg',
  //   description: 'Have Penji designers design & create templates on your Canva account.',
  //   included_plan: [
  //       'monthly_plan_agency_2023_v1',
  //       'quarterly_plan_agency_2023_v1',
  //       'yearly_plan_agency_2023_v1',
  //   ], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
  //   text_excluded_plan: 'Free in team, limited',
  //   options: {
  //     'monthly': {
  //       addon_id: 'monthly_addon_platform_canva_2023',
  //       price: 299,
  //     },
  //     'quarterly': {
  //       addon_id: 'quarterly_addon_platform_canva_2023',
  //       price: 897
  //     },
  //     'yearly': {
  //       addon_id: 'yearly_addon_platform_canva_2023',
  //       price: 3588
  //     }
  //   },
  //   step: 2,
  // },
  // {
  //   addon_id: 'platform_figma',
  //   type: 'platform', // dùng để if/else show cho step nào: addon, designer manage, night time...
  //   title: 'Figma',
  //   image_url: '../assets/images/platform-figma.svg',
  //   description: 'Have our UX/UI talents collaborate directly on Figma with you and your team.',
  //   included_plan: [], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
  //   text_excluded_plan: '',
  //   options: {
  //     'monthly': {
  //       addon_id: 'monthly_addon_platform_figma_2023',
  //       price: 499,
  //     },
  //     'quarterly': {
  //       addon_id: 'quarterly_addon_platform_figma_2023',
  //       price: 1497
  //     },
  //     'yearly': {
  //       addon_id: 'yearly_addon_platform_figma_2023',
  //       price: 5988
  //     }
  //   },
  //   step: 2,
  // },
  // {
  //   addon_id: 'more_feature_unlimited_storage',
  //   type: 'more_feature', // dùng để if/else show cho step nào: addon, designer manage, night time...
  //   title: 'Unlimited storage',
  //   image_url: '../assets/images/unlimited-storage.svg',
  //   description: 'Unlimited storage gives you the flexibility and freedom to manage all the design projects you want and keep them on Penji for as long as you’d like.',
  //   included_plan: [
  //       'monthly_plan_team_2023',
  //       'quarterly_plan_team_2023',
  //       'yearly_plan_team_2023',
  //       'monthly_plan_agency_2023_v1',
  //       'quarterly_plan_agency_2023_v1',
  //       'yearly_plan_agency_2023_v1',
  //   ], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
  //   text_excluded_plan: '',
  //   options: {
  //     'monthly': {
  //       addon_id: 'monthly_addon_unlimited_storage_2023',
  //       price: 99,
  //     },
  //     'quarterly': {
  //       addon_id: 'quarterly_addon_unlimited_storage_2023',
  //       price: 297
  //     },
  //     'yearly': {
  //       addon_id: 'yearly_addon_unlimited_storage_2023',
  //       price: 1188
  //     }
  //   },
  //   step: 2,
  // },
  // {
  //   addon_id: 'more_feature_unlimited_users',
  //   type: 'more_feature', // dùng để if/else show cho step nào: addon, designer manage, night time...
  //   title: 'Unlimited users',
  //   image_url: '../assets/images/unlimited-users.png',
  //   description: 'Skyrocket your productivity by giving everyone on your team access to Penji.',
  //   included_plan: [
  //       'monthly_plan_team_2023',
  //       'quarterly_plan_team_2023',
  //       'yearly_plan_team_2023',
  //       'monthly_plan_agency_2023_v1',
  //       'quarterly_plan_agency_2023_v1',
  //       'yearly_plan_agency_2023_v1',
  //   ], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
  //   text_excluded_plan: '',
  //   options: {
  //     'monthly': {
  //       addon_id: 'monthly_addon_unlimited_user_2023',
  //       price: 99,
  //     },
  //     'quarterly': {
  //       addon_id: 'quarterly_addon_unlimited_user_2023',
  //       price: 297
  //     },
  //     'yearly': {
  //       addon_id: 'yearly_addon_unlimited_user_2023',
  //       price: 1188
  //     }
  //   },
  //   step: 2,
  // },
  // {
  //   addon_id: 'more_feature_unlimited_brands',
  //   type: 'more_feature', // dùng để if/else show cho step nào: addon, designer manage, night time...
  //   title: 'Unlimited brands',
  //   image_url: '../assets/images/unlimited-brands.svg',
  //   description: 'Unlock unlimited brands to manage all the clients and brands your heart desires.',
  //   included_plan: [
  //       'monthly_plan_team_2023',
  //       'quarterly_plan_team_2023',
  //       'yearly_plan_team_2023',
  //       'monthly_plan_agency_2023_v1',
  //       'quarterly_plan_agency_2023_v1',
  //       'yearly_plan_agency_2023_v1',
  //   ], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
  //   text_excluded_plan: '',
  //   options: {
  //     'monthly': {
  //       addon_id: 'monthly_addon_unlimited_brands_2023',
  //       price: 49,
  //     },
  //     'quarterly': {
  //       addon_id: 'quarterly_addon_unlimited_brands_2023',
  //       price: 147
  //     },
  //     'yearly': {
  //       addon_id: 'yearly_addon_unlimited_brands_2023',
  //       price: 588
  //     }
  //   },
  //   step: 2,
  // },
  // {
  //   addon_id: 'more_feature_priority_support',
  //   type: 'more_feature', // dùng để if/else show cho step nào: addon, designer manage, night time...
  //   title: 'Priority support',
  //   image_url: '../assets/images/priority-support.svg',
  //   description: 'Skip the line and get instant access to our support team whenever needed.',
  //   included_plan: [
  //       'monthly_plan_agency_2023_v1',
  //       'quarterly_plan_agency_2023_v1',
  //       'yearly_plan_agency_2023_v1',
  //   ], // nếu có chứa selected_plan, thì hiện chữ include + disable => ko cộng price vào total
  //   text_excluded_plan: '',
  //   options: {
  //     'monthly': {
  //       addon_id: 'monthly_addon_priority_support_2023',
  //       price: 49,
  //     },
  //     'quarterly': {
  //       addon_id: 'quarterly_addon_priority_support_2023',
  //       price: 147
  //     },
  //     'yearly': {
  //       addon_id: 'yearly_addon_priority_support_2023',
  //       price: 588
  //     }
  //   },
  //   step: 2,
  // }
]
// for marketplace ============================================
export const list_all_mk_plan: { [key: string]: Plan } = {
  '12': {
    plan_id: 'marketplace-social-media-ads-150',
    plan_name: 'Social media ads',
    plan_base: 150,
    plan_description: [
      'Up to 3 designs only for either of these socials (Facebook / Instagram /Twitter/ LinkedIn)'
    ],
    plan_project_class_id: "q3JLnKukgzB2vcyEqZCg",
    plan_project_category_id: "dMFyjzD8bHZkMQHdJlYT",
  },
  '13': {
    plan_id: 'marketplace-brochures-150',
    plan_name: 'Brochures',
    plan_base: 150,
    plan_description: [
      'Bi-fold brochure (4-panels) only. Z-fold brochure (6-panels) can be considered, but will definitely take longer'
    ],
    plan_project_class_id: '1vdpFTSZusrfrSCI85FE',
    plan_project_category_id: "CoXBDUWxV7IROrj0oH69",
  },
  '14': {
    plan_id: 'marketplace-packaging-labels-200',
    plan_name: 'Packaging & labels',
    plan_base: 200,
    plan_description: [
      'Up to 1 packaging / label design only'
    ],
    plan_project_class_id: "PVCYQrJKhJIDXFvTNWJH",
    plan_project_category_id: "rUip8SdMG3uwDhXAu3xj",
  },
  '11': {
    plan_id: 'marketplace-flyers-sales-sheet-150',
    plan_name: 'Flyers / Sales sheet',
    plan_base: 150,
    plan_description: [
      'Up to 3 pages maximum only'
    ],
    plan_project_class_id: 'VF3zCRxyy515UKi3TKpx',
    plan_project_category_id: "luWm33KxnsMtkPb3uLSj",
  },
  '15': {
    plan_id: 'marketplace-Illustrations-250',
    plan_name: 'Illustrations',
    plan_base: 250,
    plan_description: [
      '1 custom illustration only. The designer can give 2 basic sketches but only 1 option will be rendered'
    ],
    plan_project_class_id: '5duz5ZM43F9VztzUfwan',
    plan_project_category_id: "NDxHrmAcPuWIAsEyKziN",
  },
  '16': {
    plan_id: 'marketplace-t-shirt-designs-complex-250',
    plan_name: 'T-shirt designs (Complex)',
    plan_base: 250,
    plan_description: [
      'If the design is typography focused - 3 options only',
      'If the design is a complex custom illustration - the designer can give 2 basic sketches but only 1 option will be rendered'
    ],
    plan_project_class_id: "7xFrINHcxy4cuwbWuqMe",
    plan_project_category_id: "wFQwvOlpopHjLvU3PyB9",
  },
  '17': {
    plan_id: 'marketplace-logos-250',
    plan_name: 'Logos',
    plan_base: 250,
    plan_description: [
      'Maximum of 3 logo options only'
    ],
    plan_project_class_id: 'PVCYQrJKhJIDXFvTNWJH',
    plan_project_category_id: "ZtyZg7l702pxXAWATeLS",
  },
  '18': {
    plan_id: 'marketplace-landing-page-250',
    plan_name: 'Landing page',
    plan_base: 250,
    plan_description: [
      '1 page desktop or 1 page mobile'
    ],
    plan_project_class_id: "tlBadhFPrOxXuFIteYUT",
    plan_project_category_id: "fpRf0oBuKd9HefgTMjlL",
  },
  '19': {
    plan_id: 'marketplace-5-10-second-gifs-200',
    plan_name: '5-10 second GIFS',
    plan_base: 200,
    plan_description: [
      '1 simple animation design that can be done in PSD only'
    ],
    plan_project_class_id: "37lEOZxQ8r4Ep4XBmH2X",
    plan_project_category_id: "kv2sj6tFKeY7wEFJU2sx",
  }
};
export const list_all_mk_designer: { [key: string]: any } = {
  '102': {
    designer_id: 'GQNUReAbl1Nx0ZL7ECFWZanEr0t1',
    designer_name: 'SL Jan Meneses'
  },
  '170': {
    designer_id: 'QozxB339tachfDdPyrG6zoCXtKQ2',
    designer_name: 'SL Maine Dimaranan'
  },
  '113': {
    designer_id: 'j3uFHxloNfOvqgEFp2zoUGz5yXy2',
    designer_name: 'SL Alyssa Prado'
  },
  '149': {
    designer_id: '2b8WPOyiDzeMRg7NsVhNjJL7Bzb2',
    designer_name: 'SL Duanne Carandang'
  },
  '121': {
    designer_id: 'eH0X7U5YAmaCAmNDrvoDkRrJXLW2',
    designer_name: 'SL Jonathan Cruz'
  },
  '124': {
    designer_id: 'aGqprP4RegXdSH5Vy4ZNkPdNHC52',
    designer_name: 'SL Rhea Mora'
  },
  '1286': {
    designer_id: 'QuEReG7TPzW1IJDnUJiaUM9bFzf2',
    designer_name: 'SL Vera Sanchez'
  },
  '167': {
    designer_id: '7x3y0yVUule0tWgboX6r1GdnzI32',
    designer_name: 'SL Nelson Mercado'
  },
  '241': {
    designer_id: 'OqMI1cafUIaWiSFKUoOWifz6BjR2',
    designer_name: 'Ryan Covarrubias'
  },
  '114': {
    designer_id: 'CS1ETkdK80PFKinda897wVrLJQP2',
    designer_name: 'Amiel Casero'
  },
  '112': {
    designer_id: 'dnoKV4rB9RXKjPakZaSuY8pDmqC2',
    designer_name: 'SL Enrique De Vera'
  },
  '117': {
    designer_id: 'lEeGpKdaHIXCwVhpoTDXeKFlR9r2',
    designer_name: 'SL Paulo Geluz'
  },
  '131': {
    designer_id: 'SzdGGeXlizNBZeWnwELWLFYC6X63',
    designer_name: 'SL Ronnel Villareal'
  },
  '1707': {
    designer_id: '9sGgxsWvyWdTHOrqTaACiUnPq0i2',
    designer_name: 'SL Luigi Nablo'
  },
  '2338': {
    designer_id: 'l8oiouxsgYeCJQSGLlU26wd3QQj2',
    designer_name: 'SL Kenny Samson'
  },
  '2452': {
    designer_id: 'qjWLRaL8FTMIrKJzOFQa1jpqsu62',
    designer_name: 'SL Jon Taranza'
  },
  '148': {
    designer_id: 'CtFATH05OgSf06ea5G0bUOj8zh43',
    designer_name: 'Jo Acierto'
  },
  '256': {
    designer_id: '0krwahQ83sN55FpkrSai29LgxvJ2',
    designer_name: 'Nico Redrico'
  },
  '970': {
    designer_id: 'AQoR4qJobMcJ8Jpj0gADdkUyYvq2',
    designer_name: 'Klinton Padojinog'
  },
  '424': {
    designer_id: 'X553591ytNdDysnFSA75mkuc0sD3',
    designer_name: 'Chicos Cimafranca'
  },
  '826': {
    designer_id: 'AsWAO6NcDZceqW8N3V2lq3eQYQI3',
    designer_name: 'SL Ed Vitobina'
  },
  '234': {
    designer_id: 'uEMn0xfwbvggzdaqmJGkTXm4DuJ2',
    designer_name: 'SL JD Sarmiento'
  },
  '1466': {
    designer_id: 'pPhcsCZENuNAKNlodAZVrVovJkz2',
    designer_name: 'SL Erlon Godes'
  },
  '223': {
    designer_id: '1gKJ2Jo8ZRd5hZ1VgPaZp4efYqK2',
    designer_name: 'Zet Clareza'
  },
  '181': {
    designer_id: 'eKf7JgfNanOsnUV8nhkhjFjgN7m1',
    designer_name: 'Eliezer Salvador'
  },
  '209': {
    designer_id: 'hCP7DjBT6sg1PQaXPhZe79D4cqT2',
    designer_name: 'Kevin Lumbre'
  },
  '128': {
    designer_id: 'neKwtli5NOXLzBLhq0mmDRtft3g1',
    designer_name: 'SL Lorenz Laroda'
  },
  '2039': {
    designer_id: 'J2Kk3dcVtBU2nKbEvAqRd6bsMro1',
    designer_name: 'SL Sav Palunday'
  },
  '162': {
    designer_id: '4vrIgugnPjN84iSKVWCOr6te6uv1',
    designer_name: 'Shera Mae Colot'
  },
  '1171': {
    designer_id: 't95EguRRBCMbt2HNyJKnEFjYKLG2',
    designer_name: 'Rose Anne Magnaye'
  },
  '685': {
    designer_id: 'UrJ2J4lkCPehYWD3JjwbAQ4jmoz2',
    designer_name: 'Louize Cuevas'
  },
  '108': {
    designer_id: '9d4CBj7xNubQQKQPGH1rKdglfgz1',
    designer_name: 'Arnold Gutierrez'
  },
  '107': {
    designer_id: 'ZC5t67ubFFW4hmUuX6CFdgLViqN2',
    designer_name: 'Jeckel Baraquia'
  },
  '819': {
    designer_id: 'fCrGC5SM2DMa0oCET7ERpj3Wesp2',
    designer_name: 'Vinson Digal'
  },
  '174': {
    designer_id: 'IqDMy7wzCMdrbclQl4dBgt3yn3h1',
    designer_name: 'Angelo Magtibay'
  }
}
// end for marketplace ============================================
export const list_delivery = [
  {
    images: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="116px" height="118px" viewBox="0 0 116 118" enable-background="new 0 0 116 118" xml:space="preserve">  <image id="image0" width="116" height="118" x="0" y="0" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHQAAAB2CAYAAAAZUrcsAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAC OHpUWHRSYXcgcHJvZmlsZSB0eXBlIHhtcAAAOI2VVV3S2jAMfNcpegRHv85xAo7fOtPHHr8r+wMC pB8tmSFGkrWrlWzo989f9CM/UQvJVXrUKL64+MUtlIuzm4evvktj3vvlcunMsK+uabEQ0yZFWxQV xFZfSWtsgY0mselu6ngjoQg2MUuXnYtco8oW1bHRW4L5wiV/+9X3kPRRIoCNek8esk3HPXwweaSB 7ZI79L6Di1VtVoiTXI9hEuNdhBv4FFkEqIJ6YVtExXIN2xVWHn7mjvf8duI2wrYRuCEkuLw8/FUe gwVijFXVX0pjGs4sr4biKbKhnB7jw3sgivfBOIC8yJrPnQnju00AMAoJ9CcViYqygJD+ZxaggFah EezrUGqFQoi4+X0hCNYDwiarKeyxFynwO98Btj9ahLUQlg2lVPApSR7SlluvXlNqw/T8JS095z1P i4TtJLmEWo7u0Jg+kz5PnsMd0AsxPdNRyNCIscFm/pR6Ymd6TYENSTR7ZwnQ/fo2lAWMEJBBMlYl B9QEY1i42jhvGY5ZEF4fAEOtTbPbkv12aAQmuuro2gxCOes4nlvGYPg4pxjZFwlMkY/VoqaLVHhB UkWEsMgDkanABW8QeEPOEiQsT2BO3Bsw5opOkPk75HNg2WleEk/oNubXgY4fWGfXyqHZmx+0uUlD H7XRvKI+M6Q3bY7I/6DNDZgO2pT/14a/blDu9P35voU930V36+ECpnmlTtfJ34DlQI5yeN7g9Aey 7GxfuuPq5wAAJMpJREFUeNrtfXuwndV132+dc+5TzysQCFmAhGQkCDjI+ImBGrANmNpJIHYTN52p S1uc2CZJU9f2kM60MU4Yt27cuPUMcWJnUj/aIfWkMXEN2HLGEJQCBhOeQiDQCwsMuldXj3vPOfec 1T++b++91tprn3NFM9OOqs2Ie8737ed6/tb69v4OMTNOlhOnNP5vT+Bk+bstJxl6gpWTDD3BykmG nmClpb5dct99IFoHAGAGQADqvxSuhSKvhXqmEOWXi23EWPF6od9sDGcQwj4AlwJA7/5fljfvA7Au jeWNYsfP50QgsLM4b1WATwY5WtWOTf/6LolW9b19Td57aZmhwDownw0is5jQg5wew52uZGKci+xH CohYvqJZYJIkoiE4iXnFMUvMV9fXAXR2zky5nkDAREY2zGJfUutWcmQWjJZjyD5IMVN/T+PmQmfp kpncvEK8TKKjwHCrsfIamQ7Ud1OHNCFTMytAYlmMxHR22qjqZP6xYoGejCayZDgbQSbxH+IVO7ge JVxPM7BWQM9P0oPM/DwBbsErzPjXz9+OF9oHooYREVj8rWhHuvtw3/CuUjjRRmisUrR8GplMhDHS fY4aun5sDT6z4abM1Of6XV357clJ7O4ng0DkjO94mzhntaZ0T36OLGC9QirojjRqgW6pf8ZZBHx2 bq4WtrwTzdDIdMIL7QPYMbenIDvlIuVc1c8INqg37bNYSawgktfM8dslX7ebgZ3gaPqZnfmzMy5D +DjNbWJdL42m50Gs+0wOQOhvsC6sDTAP4IJmaPBHZunS9OR/NWM8OFFd0CaNjSlh0VB7FMnM1Icl fPwiOyoWK9+aROz8teJnhUyuxnpSywBLGyrUC95UtmGBZTzG+mFLrGcmx/libRNPQ4PX4MhMuRhK 5s5QLSey9j9yLuy2kH5M/yvBO6i7+bolnAhamrdP8wtCL32tnTcPGNvSu9KLqpVncjVDlY3h6CME f+O0fOk2PtXMTEsmqXHj9fS/OGEy/VuzQ7ImkeOgNKiS0q4hjRUZgpmAYaDWnkCN0AepaxbcaOGw fcK5Z22nZ3g1Q4O5CsDDLERPWA+by4qWHyJSfQWjFxYuTXjSZDaCEb6nNhpDsvqjGZ7+80ynJZzF rfZzoMEUES4DcL5hQuqPFGNLTJHa7rWPK1Qx/DCUK+I57yFMrhmANqNspFUukrM+tBTnAF+PrYv1 a1FXWN51+Rv7o7qDsrtgkLqn134JET47N49x9EEAHsEoPj3RwjRLISmJPitPXlq3FN4U/pUhqqOh hcpsO0/W2fojOUGN3nIi6TZWO3JWWuJnd609Ez5He/S8iSVVBuzE5xUE3Do3jwn043q3ooPb5hYy YKLpk1xZYmugK2XT10Yn1fMDvcyHiqGJdMfG/FYS7hnanEDsaEzJUEum2TY+fi0Ejx7icNqQWCcP +KvHJ7y7D0ygDwbQq68yGD+LDi51hFDJl4YPQn0y5xHrRpPMhSW5DFUGPMeNlgklOO7LjvV74ZoG WZyNkIMfT9diL252yaJcGSr5xs4KndWyjQv9eO3PWuO4FyNxFu+e7ylt06yTV6whz2mpc7rlhITP UCM+GqxYMKOlJo+pNBPMIIZ0mnCSmDpE8DOoCjZwzsQ8aAlszDUiD3wYVpAJwAgnQHO4AfzFeCvO 4g3owgoKI2HdxdgqG6dGHijVHepDZS+ULc6iNS5IDZm6MiZjh4jeN0BrHwf0wnqciodmHqT12HpQ 3TovvshpNP5TASfXdoEnRb3T0ceY6Yccxsl+LY09GpQ0vMxQCfkGLllroLxW8nUeVqFCfXLGUY1Z myubW01505wIiUjBxujirdmbz65munoxd3FI+DoCMOmMql1SjpsH4QrrfjLa1KXhNQwZZgsEPHPH BV+rEwz64VAJ1eq0lly09r8aVBTERjTIPagmir3HzncrdA+Ia6djARtJW6ExUdsX3Dw9qDEBXJql TJHPUufxGSmxlwkrSzqpHR4zWfQgnTyynvVktXDoNF0kQBQkI7cxuBT/spJm5ON0TXzPmsww8ChG o5f+4FxPrazXkNCvXEqhkUbapKzSIG02j8/EMlhnZSw52EyWAGyaWIfrT7m8fuQD3H7g2zi0cNT0 kT/tDxO/df2NuHrqHQCA7Ycexs27/lNBSOBuhqg5nV9yr1B6JKjqecmOnNgAcOd4AxfNV9eu4bZi +nTfPrL29coV1siy1IJI9+SJYs5QQSUS2XItrUmyrWSdOboav7j6qmiyv/bTezCzcCQyUIcrVkgs uZKFYJS2fFjN0dBtUKkC/DRKPoZYYV3RzuEuAL+GBlahrwg5A8ICPE3zmauEJi7BAMKhYlAV34fW iw2LtDGYVgInScxsrucQykqkZ3xIMNUuRfrLWI/8hfo+VJpWFx0kYaJcLwiELghfGx0zYs/YhRHV a8ZER9bi/IykZ0CIEyc8k9twu65XIAFNNnrGLFvyNE3sifMaMSwxqCdFb3miXvaSx3bpH5v/pDmz wMRbs4215fj/vQkcQFOQhvBCqyGYRGpWclCbKMkZ5AUmDCnEgxnqwKpBsD4lGOTFWiAyMJTKeGME WybOxs9OnoMVrSVGPiTLtO56c1AxLnu182KJ5xnqLIak1E6O0GHCH4yNQmr8NKXPOpb2WJUizDwa sDBSrsFfY76nSATpSdY1YrMJBrcPJ0c10RjFr57xc/jg6ivQpPG6bh/bph/Abfu/OYQBHljQTM+D Ir/QgOva1yUkbX0txL37Sc/oQ902vjMyhv19OZ6/iyFD+g6NNR0GC2wR5Uo7b59LWtiipCUG95rY YzSCP3z9v8SWyY26FyJcueptOH/peuya+wmGl0RyrVVSjj2fmK8yv5sgiBevesJCAN6stIwwgT5u PdbFRyZG0OF8zNzM+yGUBVIVMi8BpaqUn7Y4Gukl0l3yRB+czOGvv+4DgpkAeAH3zvwId09vx1zv MNaMno5LVmz16K8JwDIIdyoPMbehRQAgmkUOM1mLiiRwIPJl3X4mRudhAZ9sSzBYelSea6F0ZRpQ lR1PKGaTWJkYNtzQAYbQUgr9JPO0qrUMv7j6ivo+YbY7gw/vuA17Oi+DACxrTuILGz+GC5duQbUD DxGUSQsQ8FKecdEbk0sIUBOwFJobzaDBlqkFxjt785E+z2EEG9EFQHhvfx57e+P4k6Y2q3nypISz 5Xe7MYDgObxcQ0P8SXkmJ2ewcN4KkyfYDwCXLrsgDcXA7+37OvZ0Xo7tZ3vH8Ju7/jNmO9NxJRxT j9b3eNiP00wJambhng5bKMpdHj7loCsPeVK9SwhYVrduo4FfHR/FjzEW69/Uncd1Al3L7I8UP5ix tctLIiA8miuMOcplGSJojZQA2F6noD5qF3zVxzkTa+P1Hs/jBzOPZIQ5tHAU9x9+UsUHFpzLEEea L+XRHOlj8y/1Vcq3mHDKaRuuv39uIfbxV41RzILxyYkmdqMV53nL/Bw+CGBrg7G1AVzcIGwkYBWR Ym6wQ6wEU9JZ20dP0ZyN1oO1UljUbPGAFvmwoPHGWBStg91Z9LgvWK6Hl2lHDdxZSbf0egr5uiCw 5EpqwghQLhlHhQ7DvNcS8A50490jDcJv9Bgbu30sQx9B2BoA/sX8nKRg7OsomtiJFn480sQPWsAO tmNJ5pXyTSWGWuwMK9Flv+Kzvo7LFg7HTle3pjDRGMd8f95MjwSHLSr1jwrJ+C2O5saig/SQ6vXk hLTmXlqoMQD/dI6jiWMANyzMG2yRtFnCSYnPl6CPrejgoi7wj7vAkxjBFyZH8Fg/ZwuQBK+EAPzU X51cD010CJx3lHcb00wgAI8d25Wm1WjhH66+KhOEpc1xvHnJFkgdKcVjzmiGhHLmJdij+5WpEK0T OjHwhgbh050+/nJ+Du/FvOjJi5Cr1l00xLfq3kLmQat1n48ubj92DD8fRUGHSNKHLtLkpgYWotu9 BiapZHKpFL//zeyTONg5iFWjpwAAblp7PTr9Lv7rK9vQ5QWcNXoa/u3ZH473Acb5SzZg9cgKvNKd hUXXicA21C4xvQzr7LqsRoZyGYAPz3dxHroOKKt624kmnmy1sLPZxPNNxl4mHARjFYDPz3VxLhaS eQbwlYkJPAHC1h7jsk4PF6ET6f2J+Tk8NjGJZ9mskdLMPFH1T5/VMyxbal0okzQAnLYr9tDH5/Z/ E7dt+Fhs8fEzfwkfX3s9ZvvHsLy1EiCg3T2KsdYSgAgrWlO4Zuot+C8v36MELH2WyY7ax3rnKdyl axBgNVzePRPAp+YX8EZ0s/A/jPLl0XHc0WxgNh4qYlQwoTK1PwVw08QIbplv4CpuAyCsBOO35ubw OEbwlYkRfHO8iQtoAr8718Yp6KMBxvu6fXyhlWeSwujDwxbWX7ynHTk5QucOASkFyNtmHsZ/3P8N gHsIZh2NUSxvrQAAHOnM4td2/T7AnUxUdCIjfdaoNxxTXIzJ1abZ6mq4+/eZ8fX5ebwRHbFGud2L sQtN/EmTcIi5IEZV3WMM3DLWxOfGl6At8MXPoIvPzx3Dd+bn8U/m+ugLap/a1+a2MrkO0BHFSf1p BJmY62E9fX164TAeO7wjmtp2ryN6JXz95e/hwSM78KFT34W3LN2Cla2lmO4fwQ9nHsUfHbgTryzM 4pbdf4SPrHk/Gmjgpc60CZGkmZUMMAm77Jh+vvAgKvIJi9TvD/cYN3XnJCmxHSNogPDWmsEA4d+P j2KBc2/ojUogfAuM7ePj+M12D5dzO95ZCcbb0FZw74GRfMt22oLiC6vzgLsM2nOcqUOKh4/sxI3P fs5dTKj/zLG9+Dd7vpr56FDumf4R7pl+KBMYUmPqz9lohYcDWhj1J7naK1ElBMLMX0UD/25yEugz bps/hpCl+fPGGB7O+vDpJd3SAQD/aqyJC7EEv9zu4XLuoCVq9gH8t9YYvk2SPhbRLMaHmoMwFt3q U5U6kzM40pOM9YRDM16HIpWQMeV92M+Jh1pDSyAm/JUrajDw6+1OHPt5jODmiRbOYsbn5+djvd0Y wRfHGuLgbkp1hvlLZthjJADwOBi3jDUwSeO4gBmvQwNzzPhxA/gJWyvETmZrqMmtl1inAFXCADmy LEZ39Uo8JGoX6DJYqS2rR3kWl+btrLl1V4iSCG5pEE6vDzd0AXx6ooXLe8BvdObRqs+xHEUTnxwf wVHOrYy3V8pmXS3YPMrAA0gZoiQkZn9TNLdAbttchqZ0iZ/FyUMVW4dl5YyIw1NuoaPSHiK160HE ypFJnC+Uy4PY5BaWGvT8xbk2TkU/XmmjiU9MjGM3p9nk6YKccSVL5dHYZsNSFAxxx6egcxSiNqSs z50E86qraxScLHwyFhZr6v70AnVdibIdTGfWkx3bFZ2R07f8I03yDhBCvqcFrplZ1TqIJj46OYZH uLTpWR941nP2/R5B0y/1x6JP+bjQf17rM1SAieptJnaztXXLnE1lWD6HgQETymM8yv6v2+ZxaN27 2Jfr7ynSxAtrmmXGrePjaKMRe+8DuKsxhl8ZH8Pj/SACvme2AkvmnsdUGy7Ze4k6ZFoM9aHBWVHU UHvO02509FjihRZedin3oVaek0yWJNK287GzFzWT24IZ+B4BD01M4AJmdAjYAeCQMM35PC3p9bWS 2aUB7fy6mhfDU3/GYAzKn5aG1zjZHBDOJp/Hsh54QOG+K/EEKEg8YMbyW0yBULXqaWbcC4BYs6PE wFyM8s3oXBx/MB1L/XmikB+FEK9ls4NKKG79oN2/m7eF218AJd6hJyr0rRep5TYeJxyQKPIBV/4+ JBl+5MTUNJBMk8DP95k+XbzQJt+44jmhIkM5+dEBp7P9pIE1xaQgrwZFYpqUCAfkGhx6thqaM8UE VILSFhTlW1BYzQ3qr88EC368OlkSQGOxTJA962OPkViaD2FoYkQJZtu/FmpLXfIOH1kGyQVkzHbu lzyPMkOmA4bVpNwaaLEclCopzUAKQM7aJNta47x9u57WL7YUnrZo2JCHyqWSw5MSkLK7BKT3sEG6 9mIa9ektpID/Zk5PfDxWeLAn1VFuRsw/tAigCsTZXNMI+oxPqVj3lWuqL/gttycmrB9dg/jSRt1P PXHBoriScIl02/gmQkm3jCL6RFl6e2HdpY51EeYg+ghzLqdF9ELOohDi6J7TAWLNZ329JqozlBJW vYzySxtNRka+UFK2PVMwczjKFUT/zIaPWA7qkWwbF6Ab02Nnl72eNWOZqFcC+R5GHm6kCMCtc3MZ kzWhcmvg75nVPjlZGj9c8g2yDaPs9lS9wlJxEguypUOs+NWgSo+QCgkZxkgxVu9ECPXrD0FyCWYu JNqZZWYvoLTAhcyqPJwd2BhqyLdMS49rAzVkvVjfrZGzhzDCHPW8bGThFZtY2Id+v5E9RuO+6LKf rim74CzDvhlTvb9U3Ldaq76HvgTziLUzk4KQXqK7r7DmfTOgU7pohMM1in0lC2MzTPY8aemJFGCB j/Wrts9BHjL1P47+0eXgbI3Wh16KE7+c0Gs8+asQJ1gh+d452lGdySgDjxK2sr7Wq0va5Hr3sz6G 1fO+y+tV4W+NLIISobL5PGiYYVHcYsr/ab+f1hVPaugJVk4y9AQrFhTVP1JzQpT4Qzz/P63RbhI7 E4SzyqloWbznHwP8Z8wMeWGBF4+V+rP3Sn63WNYBONtNVg96XOSVUkZxmP/zljOoX29JhTlqk9vn pu4xtPJm6hFPjkJOXbmagufn4pcBcynNbUApJalKXVgCkvN9WNRfAlvHIzxhDALQxnJbrbhJrPGl P8aSFw/4+dQsT4taAc2P9IgfzVHt1I/p6B/30bnTvI8SjZkZR9euQf+jNxY4khP/D74P7J3On3rI fGzIU2Q//iPyuP6P+PhrVNdiBky2E0kyJye8biXj5quqKSwsYNL6TH/nPAFLXjyA1p79Dvm0dilm WIotKgTKc5hKuArt9YuBq2tLABwexkxxe+804dlXR/VMxIsrqZR7VkxBqmsYKpsphrJZpXBFsV1h 9cydeNUT8+LZlvjqbpFDtRnS8FJBTWxR36ZYs6ykHJjNACWmBDZa+7YYu2XmQ4iWJmlFpQpRUMMe 5fpztErhcRbVqxKHs8K7DgPp5NMp+YQoPXgyzJRPlohiXyElPmjJhTdap4M/9oX3GcEH0NFqLst2 2cBS03PHkr9G1fpqmUNeHEOTwqU3c4d5y3fvss05h3GDZolHjPFlkKxmVDODVD8sxobQTEVzFjvm CY411MV5varn2RPx0lZJy2BLfM0U98hh/CyeR5A8kJNOPrPbJj2/oDg3Og5lFVkyuwaCMsWebeFA aUtkx+czBLORGKwydXJGRJnILkZQ8z1FGWP0da1FVmLk0wUtGAxpTjyKJy3NrUIpHNGvetHHCYcU Ej5S+rTa3GprTvksJMBRVbWPrLRQPhEkwIAlmPbRhBvqsPyCXI4chuqS79FeVJwH31xqU+6NRqat /7bq4/k+PCbgmsiJkc78JFBRzOV8pPAq1poxUjiUZpu+JZyNkYl6Xpxrqgf+HVBUTU1rUvos3x8Z GFU6lhs2jaXFl0FM2uqShGYw3pMzotiHXkxBeIxnsT5S+iwNmtI4yk+SGY0F+AmaFgRGUtXMV1kB sY3HeRVoDGtsybegDAnQWRE8sMAHKIM3ahvAZABHCmE87yUDnNLb+YYPLTdeyRAkjsBV7zKcSXQS WuSAv6it8rOK0y34EX3FEEf3J2CTnIYq/o/ZKQJ7ZqsQdkDuTBtEYAfFkmac3d2Xj6fzdOpsqBpj OKMl2sxDg9wUstl54Tqi4Cut/zVgh4TmenRiYTXSbIGSrjhhi73Ai7iWGhs4UKiXm8IkQHliQW/C IrceBzO3WFAEaebF+OHnkVUsqpkh40ufDXFCWXYozjygJc0tXbKXUEH9auQiQZH0oYsxZVpThoMo T/MJVqOo0M43455/HuJDS8syVorkJWlyhTAorZMoFknMtdKTMuFKqFQalDS4CnUGpAAWEYcOk3hr /qwQEHyLUopFbSZomEAJ7S28c95tIqqooB+5fxuU1qsvaHMsbYoJ00JYJi0SLUK4VDpywCqLcaiO kUr+K13LEaYwmWpfrdTEsun25qRqOeMNy6KU+olBf4wwkl8L96IMGE2xMajFSPaHipTZrs27ArFs DonZ1+UMWWIhDrVJg1KaLfk0zTS1BFiMpjVZakaWGzFzkpJu7/MAcFEuKhnOAd2y77+ATGhUzrtm cmCaJ8YRxYo5e9Al/3WInDTeap2zLSQGsq/Czv0UA5j+e+8AzlzrU6zfB2ZmsfyJp9HcvddJ4SWG 658jhvhM7tjl78dXyCBZuVKFEGJsmO4wMy5Z38Ybz6iYsOsg8JdPj1X0k/ngusXVm9u46Yq6ww5w /VfHMtGOIYxy4M5yHY76b0GBQHdsewp1BKG3Xghc/AbEaDcz1YRZMPCjR7Hy9j9FY25eRJEiolQn x+2c5P0AMzRTj9fkWrBTwvNKuyCWWM/lxjcBq06tKl/ZBbY9x5jvFoTCk5ZqcdHNhbFei4g6oCiN mJtcC1Tqz5KBJOshMRkALr4IM5/4GLiZfudE6Wt4jKTi2iS78vfOvHmV88ROiWGiRqtwPsd5Cv8X 5rL5tHbFzFBGgcvP6cTZURwrhVfZVKTjFYCpuJIBnC68Go4c0CEoEf/WhJeMf/kV4O4fpOojI8Cb LgI2rq/qvn4Dpq+9ClN33mXG9EzroGxTPqdFx6FiGJUhckKWOEORvZHG6+pzzZAMXLsZuPuZ4EZQ n9yoKj2wt4mX7uyBGej101gurxxPMswKFX1ofk0P55s9Bg4exNRd22IbAsD/8x5M//ZvAZs2VFfe dTlw592iHwYaDSysXQMsW4Jer4/RAy+DZg8jN1hl/2qzTcXC+Vf7w3Z25UmD0p+xJuOd59aVekCv DTQngLPPANYu62D/7Ih2d0SY7TSx85VGNV6PXVWRLy2Ric0UtpSzGs6eolKArqnhkktVFfV6AH64 Hdh0TnXrlClgagUwPYM+EWbefQXwvvcAK1fGdsdAwLPPY+w7d2PywUcdpnpATZFlaLE7BGRvNq8a exY+7tL1HWCkavTEHmDPDHDtRVX7azb38ZWHdJIAzHjXpk4FigCgA/zCV8YEI+v/yaR8aWUFeXXi 0MrkeuZLP1VxZNndH1ExYPTwUTWT/lj1k6kz/+DngX/0QcXMWG/TerRv/ueYfs874VsJbzzH7OaJ KMvZCHCiX5XbSczI4d61W1J/9+wEvrczpeWu3gwQcVHD7TQ5ToPz2Df8lc9pX5uGatL5IYfRFMr7 IRA6mzaka70+Ggen0T/1FOC9766ud7tofflrWLpzFxZWLMeRrRdWprnPWLH9QWCQCVVhj7OOAUps fWNlzfRORI+Gpy/rYeM6xPBj++5RdHqEmYNtrJwCRpYAF69t46F9Y3oKWWCa5iHDG2/aqhTgwqJB kTbEA14/1WiCJ8cTUYlw+MLzgKhlDDzxNNDp4vCmDan5C/uwbPuDAAgjr7yKqeeeB+7ahu6a09A4 fMRlon0QUH6jtUMMgTxtuMcAKNtyqYHTe85diEPd+yzQ6VV1v78TuOEtVT/XbgYe3GfCRsdThH5V 7Cq3z4rvihOLikNVwOr7VC9GjOXcczBz+38w+SxRt9fH8j/7NgBgdL5dv1cPFfr9wM9h1Q/uA79y sKp7+AhGoqmW87GRdSWuRQToZRMFyq3o5WhIILLdm8xcmdu6j7ufScNse66FG966AADYugFYNtbH kXbD9YkhqwQP5dpnrCqhURZY/6UZReJojcjETA7oJBfQ66H15T9F8/k9AIDxx5/C/IGXgDWnVfff fzUOvv9q4NWDwJPPYOn9D6L1xNNocCljVWtm0Nbjz/zVTEpTjO/RYJ/JYMbW17UxvrT6evQQ8MRL yay+ONvE/pcW8LrTADSBqzZ28T+eHBPC4fNDar+7Yb2e4MDsKAb8iAC5Izs+UwkCgH4PmG9DzfxY G3j6Gay482409r2YmiwsYOozn8f0r3wAeOvFQKM2maesAi57O45c9nbgqWew4otfFmY3D5WSyNiw xp9q4o15ybKpL9GtFOFrN6chlqwAvnVT2x+AgGvPA/78Sd2fmUSFnIXg+Mys65bAvctQTtMva2iB aOH6M89h6rO/b/ys5bog0exhTH3pq8DX7sD0hecD558LXHQhsHxpdf+81+PQx/8ZVv3uF0zARKqn gaCoQGyFkoN2FlqGHpeNMt60oUAOp8FppwIbT+li16sj+l74S04Sw6G64ExO+iJDiw+1RfDufIrD BpRItAiTXf9tNoBeHzR7BFN//QDw1/8LaDYx/b5rgBuuq6qd93r0ly0FHT6s+rIbl+MOu0Wa3mDE o3YokGQtUKVFV2zqJKox8I2/gXp/COrI5UNvRPXzSwRcs6WPL90v3KL0VCysYfAaBowpptJgYXVQ bkNJQCJSvWc286OG72bC1mCp9/1MjGP6dz4FbLsXU9t+CLTrn/jo9bDsRz/G4Ruui2NTt1v3Jjan cTbY4v2odPPyogMipSJeszndf2ovcMejY9kqAWDNsjauvLC6+K5NwB9uZyywtggWFEVFkEn6UmJo 8SY3oIKaeEHsoj9xdrF7iWyV0VGGESHkmL7+OmDNauBDN2D6F64DHnwE2P8iMDkBXPpWRDv4wm5g vl3caV56OlMsQSEMQeXRCJIX6s/rp7o447TU/u5nkkbZtOF3dwBXXlB/GQfednYH970wrrW0jpdS SCPjYfmWogHZuYEMTd5XEV8yxU/5WZ+a4lkdAevvEw8/irk3nA+sXQNMjAOXv91Mm4Fjc1j+x9+o xs5Qv52nWkS5iFAvLt2gcrutEwCu3dJPVTrA/S+MqpXKfbg7XxnDwYNtrFpV3bxmM3Dv86xRKqc2 McXIubaHOmVXVmKoGCl/+j8A4Ox/EVgyUX3ds8/Up2Lb8ad2YvxTt+LYRT+D9pu3VrneFcuqxxAz M8DfPoWp734fmDlkWucvc4r7gNLDyvKqo4aKXXnq+aP/Bu3VS4A9P6naP7QP6PYb1egFUHPH3yYT Pd4CRluMV48Bew5U05xbgLICvigKECSZufjUn8c+nTXSU2dM3fEXZeIhN5GqPfex5JHHMfnIYy7z 1csj617Y6T0yhkTfQ0ppw5U8y0nCMvzO98Z09ogMojAJgu/uGMNdOzS1Htw3jgf2Cp+JsLNQP5qL WspaNY4TFImlZdtBPLZ4plZ+l0thw8z018mTpCtmR70WEKOpal/TcI9jT4O5rUQoY02et6ljIFKu G0l0rtoLlGuf0rhkdUph158n3WnJ+qlLaOf7SUGOQlthvLOnNSS+2fg3aCM5WuwgX/lPgB8OhKdU Ve0ecOamzqhYLRcbrLMFKuZpMEm2DyBLLCxmh03xBchBtfONYpTplW1r2ATJYK+tNJu6jTWJ2joI uiMXwgGZIuFDE1MyZyCymflReS9il9cC/eRTyCwTpJieAx5vh6Hc67XInfN65f4zdevVPI1m5Jpa XaeCocuPObDTpySNJqX2L6XxoTQ06xpJccgJ8OsLafbOQ/JoJmUYVHDpkslFry+OZcjjicMPK6k5 s2MYC4MqAmhmeQ+h1VkVZbKShhZ/Hjp7REYD/ubm3c5ZmrgoAjK/4OybdZ2Js8s9HiEU+3VDpOJy JDBebEZzN64NwHuFsy0SgWmGeBqrXgiRAZ4UqeXpB29XfWhltdAbo7r+GvZX6/RbtqLEJJbMkUwQ p9Us8wOAiv5U1NFCrx1QvlldrFf65QG+tHC2xVts1XF+uDfXwNL34ec4PdNryW2BUlAweSTfSUkW FDZogWWOEjMR/GcBvjLbGsxY0MMGMPkgmB1fmsYZBuSLGqoO0whKaJmyYUS55BEfOXVI1bCcINJ3 Bx9dHOBDY9SgiV6cWdBSsd8nMA4W2NT17LNUO1NPvoJwRdQu5xb2PPlEjcUJWxghFNCEs9kjheni Jf/Qko4dc4xozbMFRdI8Sw22mBPZeBlvrRLHZLjpMfo7zfCB/lTuQTKMlgyzsE3VU6a1IIyLN7l6 mvpXhvROQLnMRJs83yq9oiVAIFyqm4XpaTyyVmLQCgfYWI8TYXR72romqhLbeDgpaaeCYcbXUsEC GFXQiDnr04RPxweK5JotnvPNImdaTYU+KE4w3hexZ+m1cFUWSI6az8taFcOrMn/V8UAjnLFKRVGr eRmYio8Yocy0Zbw180qQxIHhdEqNUigUG8HVVCeXW3V25IzTsVS2NaDAFQATkw06NBvup3OY+lmp rRNf2eazDMyMo2ecDtcwFkzUmVMAUTs2cV88Ke6VDv4m2hlQJNbuvcBRr0/kNwQGs2XdysFrch5w Vz32P3pjdWIsg1QexKLB34eBW7cMchYlM1tKSPjl5qtKdQOCZXNb+kV7mf166vuwhMlxkmc4KMrj Pu26SX9nW7fEbO+vN0O7yGG4+bUEoMdReMg9D0QPm5IX5b3GOJqHmtwmvQBgwZ+BgyKzrZrSuAvm y3BjoFO3bYesaHBJP1JDzvU2lvV7mFTTNktQWR2Y++GrNJX5WD74NmSLXdIix6mvz3dwcKml4Gt5 L8HJ8v9uOfmrECdYOcnQE6ycZOgJVv43vyH7cZac6fIAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjMt MDUtMjVUMDk6MDQ6MzkrMDA6MDAwYuN7AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIzLTA1LTI1VDA5 OjA0OjM5KzAwOjAwQT9bxwAAACh0RVh0ZGF0ZTp0aW1lc3RhbXAAMjAyMy0wNS0yNVQwOTowNDo0 MCswMDowMIl3NtIAAAAZdEVYdFNvZnR3YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAAAAElFTkSu QmCC"/></svg>',
    name: 'Any',
    value: 'any',
  },
  {
    images: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="116px" height="118px" viewBox="0 0 116 118" enable-background="new 0 0 116 118" xml:space="preserve">  <image id="image0" width="116" height="118" x="0" y="0" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHQAAAB2CAMAAAAujEceAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAACOlBMVEX///8A2PoA2PoA2PsA 1/oA2PsA2PoA2PsA1/oA1vkAxOgAxegAxekA1vgRNWQSNWURNWUSNmUSN2YNU4AOVIENVIEPUX4R PmwQP20Av+MAjLQQS3gQQG4A1fgAkbkRO2oAvuIQSXcAx+sQR3YAut8SO2oAi7MCbZgNVIAMWIUA dqAAvOEA1PYPSHYQOWgAoMcAj7cROmkAweUAyOsRNmUQP24Cc54OUn8QR3QAf6kApswA0vYA1fcA y+4AtdoAmL8EbpoRQG8QQ3EAcp0QTXoAoskAnsUQUH4AgqsGa5cA0fQAyOwAhK4A1/kAtNoSPmwA 1PcAeaMAqc8MXIkKYo4AmMAArdMJY44RQG4QNmUQQnELX4oAirIAw+gAz/IQRnQAn8YA0PMAr9MG a5YAwOUFaZQPVIEDbJYROGYAhK0ApMsAg6wGbZgJZ5MEbpkAu+AKZJAAwOQRRXMMWoYQTHkAze8A g60PSXcAfKUAt90Aut4Ak7sGbJcQRHIAgKoAibIQS3kAyu0HZpIAp80Aha4RPWwOT3wArtMAlr4A hrAAh7ACcZwNV4IAmcAAzPAAlLwRN2YNWYYAgasA0vQHapUROWkLYYwAm8IPQnAAo8oROWcPSngA 0fURO2kAxuoAdJ8JZZEAibMQVYIRSXcAqM4AweYAzvIAstgApMoAuN0AeqQRQnAAu98Az/MRQ3EA zfAAncQQPm0Az/EAzvEQUn8AwuYAkroNXooBd6EAe6QEcJsLX4sSRnT///+iFPlmAAAABnRSTlMA ebCwsHmPVFKFAAAAAWJLR0QAiAUdSAAAAAd0SU1FB+cFGQkHJrD5PkoAAAI3elRYdFJhdyBwcm9m aWxlIHR5cGUgeG1wAAA4jZVVW7baMAz81yq6BEdPZzkBx389p59dfkf2BQKkt5ScG4wka0Yj2Zd+ //xFP/ITtZBcpUeN4ouLX9xCuTi7efjquzTmvV8ul84M++qaFgsxbVK0RVFBbPWVtMYW2GgSm+6m jm8kFMEmZumyc5FrVNmiOjZ6SzBfuORvv/oekj5KBLBR78lDtum4hw8mjzSwXXKH3ndwsarNCnGS 6zFMYryLcAOfIosAVVAvbIuoWK5hu8LKw8/c8T3fTtxG2DYCN4QEl5eHv8pjsECMsar6S2lMw5nl 1VA8RTaU02N8eA9E8T4YB5AXWfO5M2G82wQAo5BAf1KRqCgLCOl/ZgEKaBUawb4OpVYohIib3xeC YD0gbLKawh57kQK/8x1g+6NFWAth2VBKBZ+S5CFtufXqNaU2TM9f0tJz3vO0SNhOkkuo5egOjenf pM+T53AH9EJMz3QUMjRibLCZP6We2JleU2BDEs3eWQJ0v74NZQEjBGSQjFXJATXBGBauNs5bhmMW hNcHwFBr0+y2ZL8dGoGJrjq6NoNQzjqO56YLRs9kUdGcIJHA24GDqVeDlxVh+Sc4/TnuNU3DLSid 35CzBAnLE5gT9waMuaITZP0O+RxYdpqXxBO6jfl1oOMH1tm1cmj25gdtbtLQB9osnzCkN22OyB9o cwOmAzL/vzb8dYNyp+/P9y3s+S66Ww8XMM0rdbpO/g1YDuQoh+cNTn8AJjBr+DnTyocAAA8YSURB VGje7Rtnox1FFd593ll2N3PO5N3oE58dCwoRDTEgYMFKCSqKggUVQVFRVOyKqNiCHY29V2yIwa4/ zpnTZ1++8o19yb1bZufM6W3uGWc8fDy0x5lbW6uteqzoc0uu7NhebW3Lw1X9XMkAHrRqB13JtZ21 r/pqP2m7egQB3Vq3I9W/9pXonC/odNCbSR4kOg/j2sXAb6/1bko+Vzsb1nqsDKi94v+HHs46ArFh 8Y1kl4O+qXcr0KTPtwKmjlx7xwHFB0nniE+SLCsZXEZd6BHv0WkAGpeelDBh8WshYI90HaJ0G9rw 1BFGZ+vXvoo8DdxcjlvrkgdaUErdbINzhGhLAyNYIzItMgI9axynaZ6naaLvuX7y+ShnfMz11lw/ 6at9TPJee5M/eIL2Ar8sU03zgQZ4UPK2dY05Q8acseR6lHaaEbFdQ/1sz6A9rsPqXaAxfBTkge2c 3+ZzGtQ+EHjgTERUoO1i9lmyvYgETG8gT4H8EDEOxdLWieF1BZV5ifWY1p0gJcK0LRd1erqS5cfF 01yEL89cMhowDJ+2mmxTjkFlVowpP5X3gM4K5jBlhrAANPrFZYHQh6iGMsz4MpJiCKakaaMvrf4r GeI6jdptIUwNEEIYUQQAg0JlAhDLeTXTQk/Tes4uDvQJ9oGBf76GEnFmiEyZwOzwDhB5kwElJZvl OWK35My4idyWyDGdnQSFADrmYI8DQSYyhsH2pglNRItJagZwUQzYyrJgITfMFZ2nF8RK5w5TkuSp lzyMhGvzi9KhChl2SGDR0YwyC6MgoBOOZLhcepOojGky6hkiy0zjL6mH2AUgahsuYKi5+rR7JWAy ksQ6T1PDFFV0AFT+SZBKFpNUiM6sOQ0jQU+MCsBSlnkypg+SRap/KxekddVTfssEwEXFzI8qQh2K flfHtLWi2Z/OcBHhRvLlSl7iqeGJgVkQqEPCq8wKamRrrIhDIDAjQLf47hhdG2E6Mp9QJcDhOWA1 j6q+HbJRP0UaUOfhOaL0rsg4jKIaAZ7IgaChEqZGuCxIH+SeOQ0oaqQUHtfByyhPg9nGxjQnDBOh RGxFyJx5EUs3MOiDcIoqQ+HM6DDBTIlOI+8WcChtWRDgmEabUxXSMVnaxbTu/WlVGTTjixGkLgCC K1V8mPugL8mrzNBGKV9uZqBpESONzYaxEootVzEgLSjRizj3IJjrIMwo0hzkqE43U/xr0lv/JtXA KiHqQMDFhIKWovMYTz06MH0sxf2ek6sN2B85zJ1TiMsu4DbW2G4Ct9DW3rkbRLrfSS8BVS/DXio6 1hzcSQnk0/AJWVrYEQB5mk6LbFnzMu4dJqNuGGj0DVgGJ8eGr5P0hUXyMyDjELxM4+lIzovcNOQu /CnGFI0NMQBHdnZlGSFCFg/h+C54uhbyijKHWNT8KrqYRr8QH6EGEPoqisYCO8hmBochurYxUkMt PmZ130ZshxY0pai4sOUMYVOQXxwpdxGgQzVJw2iISUTmPgnltpFWTFZFJAYsEMnbBxYivZRtxQh/ AuisaOmu+vgIxBL7CEotSjH/EgRITWgD2tKrrc4imW6QqIlnxX3iq/QocTmY1XmrUYxBmdCGpXe7 i3vN8XVviWVkIiOHF3E+9wodRXS5Eo9QRMz+1IG2tMKwAhfYPigxFVX2AkRSWhyIkVPOmejatihp HeNcZmbMRAUz6oKimhGQszhS/Zz4m3ZQYCYWacVmkAIFVksN39rggzs7O5vNZmdzqP6145GPUhk+ HVV9OTqVcbc3+F0ISvLmvM27IZFfc2L/6LMf09ZVOkBisp3f4IIh1J4pf1kFg8/kJXEB5wbmva6y IgWJxz7u8RqJsOOHiCZ2emPijWPq0goiryyscByqIkSYpsHLR/zxhCd6iCbhi2Uy6GLloR2wnq73 6Wmvkawbu1p8CoWzhvaTnoy2MKM0qn8VMZSkQjIyipHSMoFCzVWyo7qbuD4j1Skp7tR/5zzF3a3k khaie3zMtOc5p+BPV1QLGk3uUDMKOtlNSctuqa8JPpVheN6Mveiq3ba5uLoSnHga0W1CZL9K79M2 m6dXzdk59xnPlDrXeef3mosYYlIFGBV7XmBaeaoPwaoVZCMU6MZE4vCzpB52gcuS2X+z1iLH6L5n qadkkcBfw2yGbE/kdQNWvnj2c5jKRy4UBaWXCvMENGoDUHaptZ7WIVUcWJAgLlVLZvmoFBgPhRjv uYL9MU0HLrr4eeMl60sve/4LXvgiK0ep4hUVsTFUV1at1DpMYAFDsaikrn5Pip+HzAMgXi6Vyhcz 2V7y0gNeujzvZS9H00+U/JHD4XlfYNZURrNT5a5IL024A6b5gJcxhFfQ5RVXei22MerABYdtBvcJ ANBhSu9MIncKlBcAQZDkaNS6ikFc3YZccTzUatl4XfPK3C1fzqe0qK5wxYyEraAzH/GoWKCdELkc fhXP/+o66vwr2XhYEb/+u9bMrUazYCFocvKmYXIDYmEYivQ6phzFvGbNZezX1tHXcVfgda+//oY3 vPFNb27I3PgWdYzR5qtri1nbtDApmivtpgV566O3rslMHb++Iv02MlY3HSQTX254+80kXxyLsVm1 eKPPTynC1zi1S4ZzVRlm1A4lHKSMtwgTb6rTvYNN4zsbhRqQcuu73h0MmsljthhJLVLyipkHRwL9 qFjchik057X7nksTl+lvqyx7L3P3feZmNFAO0aDmkTGXYfLO4TkrLIcju9IEOUJV/Gk8cjyJN7/9 YB35fr74wAfFoHThoNokkcm5tRaS295EQJUQ0fTvsT/V/oh3PI7f0dTrQ6IoH/7IR6PsmKUJlVjK xN32CnmLEib4GtzrG0Pe1PoYT/Vxa2594pOfulPXjZpluDVfmMHExsFTHY9A2cuEZowB/7Tw4o5L bTl1yO13fSYaBHevbdbTNQ44CLQITuLQo5GmBv2zn7MQ5ZZLGKKMOn73MXU8Fq5IYa9TmUHDFYtl QQUOKtAh9MMY8Pj5L2iIWh3YF7/kzcWqXOmsqy/UjJJDFxWVsYscEhU69sXMxAuxvenLJ+6558Q9 J06cuPgrx25wQaO1ffVrXydLqLb3G6IxYJQlGk60LgXaYqAZLagrRmmSXsZvg8FaaUvKctZvfuve a78tRK7jvyMW1WVELVLIT5OFK54+i1vaE5+10cfSFmPAEiQQOU9+93tXSsh4TsgUNaMhlelipCQ8 pYkg1hN2RUs2qI4v5E6WF8uKv/8DWeKdGmaV8Hwm07aQXmcqehV5V1zzIedzDsWXjJdTaZ+SkZJ/ eDsv8dxF3y23/thEndwYDU6iT8pN0dNiThw1Fw319nr86Mdn/4S6CMyX61iWjlnQE1g2d/40ra02 aBGGzi7GofFUo7qYHuLd6/VPf3aSsK/DT97MerXbyxCSyJ2ujuTCKROD2t420SZ6jaw2Gn9OBv+q X/zywrbGX/2ardY56lBVqeilsctlmspMpnW6QG7n7Q0sSTugroeNOZPk5G/U8v72d/fd9/vjoqx/ kBJUVuVDBRrJm5JUV6wtKMYT98TkbtSAg9RWiNh/vKZv/POGgz+ddMEOlbuZhnWCtK8ZqCrD4rtx uvLq2f/deu+fzfeJ+R1uvojtUCxdNmaMncokLnQY11ELACRIbFF3tJMEnWrmfP/Zf9EskoLC9MD1 6sGtw8PWd9E/bcG2F1OcJvXsr6dOPfjgjadO/S1a5a4fjoeveOCIlgb+/o9jtFrtFAN3eRlTEo/t aBxiBRzNF1pm7YRCbltoyYfN4v3/vO1f//7Pf//npkx54C61qyMlSRU1bnACihSjVWNVz8F8b9Ak tMayQs2RrdAVmRlosKgWK1lbROI0K/Z0GUPvE8FT8M5e5r7XRjtAJiNi83E+FgpEsdGTYlNGMli5 Gbzq7wn6ItiWEJQJWbToQMk4cnqLiB16luxoidZTf74WqKhdsPo9DUPq6r2WiaN21XTerjPA57xx xJJ8JxGvLzruKOULJ94w7fpa1lWDvvBlkomm/3Yja+SpiwuST9cTKXyMe2fBk0jBaiC2M3QPXTqC qcHsBaAoOBghL42DuDbgGp1H5YDWEMjZO2FeCPRky717T1QJVORtFqRVMPhzsR0RhkUxOCKy5mwN +9BSCKQF1MDMYkLKT5utjOX0kaMta6Kp7tumAaOuaYMYo649p4uJdTRlbZeJDxw5QPeaL9ouRNS0 /RCdevDrkEPpzEa0MdOwXi+LzMH4uu01xbPdKH1SH6SJ6aMiu2jfF+gTKOqfhnDF9C5M17AstiCh bFFlVjBBw7TcSm+pRYp9GSnTmbbvY1DWjQDqACS4D8a6t5RdbVPWgH1XkfV0n5qFc2DBXUzENCmq L2iRlc1jOxZIiCfaB9lvOYihRcxmTGC1EAFFdbKLgEPnNYgzaOsLMydQMVyZvNMjc0IJDEQ0mG4R 4hYcfVg88g6CS1NSxSzFvSuzq4EvVKvrCKHeEjTFPXbIvILMmrMhqnVbDhKnFUUl0JTxdJbNW52w eASBCmExbh/YOKzcy6TJaRVTH21pAualxntgawg5WXlACXsdM46LaLAG2yr24Evzsrhg2HyAqT92 rk8MJ5jg8XaHri8T89NkpddgWlw0xUIVLk8Jb6Gjue/CoF1goJ6u8CYxrqtymW5/09YVLcS+Kh4a gMhusNA5gi56sMChCOeV0YSp56fVoY+Leh6q7FofE+K2KjLFtnkpm7mOfT3XGH6lz8ST5zJCt6J2 rQvlTRvcM7jghXaBKmeUuia91FQyM5iS7RuEUPftdcX2QKlYiQY7caxqYGkM96W1CppSAMpmsGgM gFLdkU0Zyi3rswT77hY5MEYENu6FokVOsSBJtbcDbWv0JNui275n+pr5X9s03W6MbX/1TBuqZ95M 3R5SSbY9lXf4/si7qyfeSN22Up/VRfjWttMO3qLmafnumvfYa3nSSnc+3Pf79xvEPWOOW237l6kZ kGTHOfcvvVesEw3Jtp6nDuBactoU16ELtWhw8G36tgvfMesQSqFjPNhMNAUnxZqWJ8c24ByrK0M3 2eLnBsn36KfEvyXYT8th3e2+T/HL3o7NIP2hgkzjPwMQ6IPimLRT3f9GoBcC534Eb+tjoGeGH57I 71O27fcm+lsU+zlLveSn2/7rllX4iUr8YUv8jcvW9jZfnnnGw8dDe/wf2WCpQ8oOmL8AAAAldEVY dGRhdGU6Y3JlYXRlADIwMjMtMDUtMjVUMDk6MDc6MzgrMDA6MDB9IlPMAAAAJXRFWHRkYXRlOm1v ZGlmeQAyMDIzLTA1LTI1VDA5OjA3OjM4KzAwOjAwDH/rcAAAACh0RVh0ZGF0ZTp0aW1lc3RhbXAA MjAyMy0wNS0yNVQwOTowNzozOCswMDowMFtqyq8AAAAZdEVYdFNvZnR3YXJlAEFkb2JlIEltYWdl UmVhZHlxyWU8AAAAAElFTkSuQmCC"/></svg>',
    name: 'Photoshop',
    value: 'PSD',
  },
  {
    images: '<svg xmlns="http://www.w3.org/2000/svg" width="116" height="118" viewBox="0 0 116 118" version="1.1"><path d="M 9 59 L 9 108 58 108 L 107 108 107 59 L 107 10 58 10 L 9 10 9 59 M 72 45.500 C 72 48.833, 72.167 49, 75.500 49 C 78.833 49, 79 48.833, 79 45.500 C 79 42.167, 78.833 42, 75.500 42 C 72.167 42, 72 42.167, 72 45.500 M 41.663 60.701 C 37.977 70.490, 34.970 78.838, 34.981 79.250 C 34.991 79.662, 36.538 80, 38.417 80 C 41.551 80, 41.979 79.623, 43.569 75.458 L 45.304 70.916 51.813 71.208 L 58.322 71.500 59.867 75.750 C 61.316 79.731, 61.653 80, 65.207 80 C 67.293 80, 68.997 79.888, 68.994 79.750 C 68.991 79.612, 65.899 71.400, 62.123 61.500 L 55.258 43.500 51.811 43.201 L 48.365 42.901 41.663 60.701 M 49.179 58.239 C 47.969 61.682, 46.984 64.838, 46.990 65.250 C 46.995 65.662, 49.025 66, 51.500 66 C 54.564 66, 56 65.578, 56 64.678 C 56 62.981, 52.947 53.739, 52.056 52.739 C 51.683 52.320, 50.388 54.795, 49.179 58.239 M 72.667 52.667 C 72.300 53.033, 72 59.333, 72 66.667 L 72 80 75.500 80 L 79 80 79 66 L 79 52 76.167 52 C 74.608 52, 73.033 52.300, 72.667 52.667" stroke="none" fill="#541e05" fill-rule="evenodd"/><path d="M 2 59 L 2 115 58 115 L 114 115 114 59 L 114 3 58 3 L 2 3 2 59 M 9 59 L 9 108 58 108 L 107 108 107 59 L 107 10 58 10 L 9 10 9 59 M 72 45.500 C 72 48.833, 72.167 49, 75.500 49 C 78.833 49, 79 48.833, 79 45.500 C 79 42.167, 78.833 42, 75.500 42 C 72.167 42, 72 42.167, 72 45.500 M 41.663 60.701 C 37.977 70.490, 34.970 78.838, 34.981 79.250 C 34.991 79.662, 36.538 80, 38.417 80 C 41.551 80, 41.979 79.623, 43.569 75.458 L 45.304 70.916 51.813 71.208 L 58.322 71.500 59.867 75.750 C 61.316 79.731, 61.653 80, 65.207 80 C 67.293 80, 68.997 79.888, 68.994 79.750 C 68.991 79.612, 65.899 71.400, 62.123 61.500 L 55.258 43.500 51.811 43.201 L 48.365 42.901 41.663 60.701 M 49.179 58.239 C 47.969 61.682, 46.984 64.838, 46.990 65.250 C 46.995 65.662, 49.025 66, 51.500 66 C 54.564 66, 56 65.578, 56 64.678 C 56 62.981, 52.947 53.739, 52.056 52.739 C 51.683 52.320, 50.388 54.795, 49.179 58.239 M 72.667 52.667 C 72.300 53.033, 72 59.333, 72 66.667 L 72 80 75.500 80 L 79 80 79 66 L 79 52 76.167 52 C 74.608 52, 73.033 52.300, 72.667 52.667" stroke="none" fill="#f98104" fill-rule="evenodd"/></svg>',
    name: 'Illustrator',
    value: 'AI',
  },
  {
    images: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="116px" height="118px" viewBox="0 0 116 118" enable-background="new 0 0 116 118" xml:space="preserve">  <image id="image0" width="116" height="118" x="0" y="0" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHQAAAB2CAMAAAAujEceAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABv1BMVEX/////OcP/OcT/OcP/ OsT/OcT/OcP/OcT/OsT/OcLsNLDtNLDtNLHsM7D/OME1CCY0CCY1CCc0ByZCCzFpFE5fEkZdEkRc EkRcEUNcEURACy/fL6d2F1dqFU5pFU52F1jgMKdhEkinIn3ZLqL2Nrf8N7zyNLTaL6OoI31lE0ti E0jYLqFdEUQ1ByefInf/OMOLHGffL6Y3CSe8KI2TH22iInmiIXhqFE44CSjlMavwNbOUHm1YD0FB CzBLDTeAGV7XL6B3GFh/GV28KIw9Ci2HG2T/OcDULJ7EKZI3CSlsFk9FDDP4NbmHHGR4GFmYIHLO LJmfIXf/OsNHDDRxFlS4J4njMqnGKpPCKpDGKpK5J4nAKI/KLJaFG2NoFE1qFU9TDz3NLZnmM6uG HGNxFVOVHm//OcF4GVn7N7v+N736NrqxJYREDDKkInrQK5pIDDSMHWj/OMLZLqG6J4vTLZ2RHmvM LJnfMKaRHmxECzHiMKjhMadbEkORHWtGDDPVLZ5GDTTtMrA4CCmeIXX/OL6zJYWCGmCQHWv7Nrty F1S7JoqOHWr5NrlQDzt1GFZ9GFxhE0c6CiphEkdeEkb///8Rm9/AAAAABnRSTlMAebCwsHmPVFKF AAAAAWJLR0QAiAUdSAAAAAd0SU1FB+cFGQkFMQEc2Q8AAAI2elRYdFJhdyBwcm9maWxlIHR5cGUg eG1wAAA4jZVVXdLbIAx81yl6BKxffBwnmLfO9LHH7wq+JE7ifk3NTIyF0K5WgtDvn7/oRz5RC8lV etQovrj4xS2Ui7Obh6++S2Pe++Vy6cywr65psRDTJkVbFBX4Vl9Ja2yBjSax6W7qeCOgCDYxS5ed i1yjyhbVsdFbgvnCJb/96ntIrlEigI16Tx6yzYW7+2DyCAPbJXfofQcXq9qsECe5HsMkxrsIN/Ap sghQBfnCtoiK5Ry2K6w81pk73vPXidtw24bjBpfg8jL4Kz0GC/gYq6q/pMY0FjO9GopRZEM6PcbD e8CL98E4gLzImuPOhPHbJgAYhQTqk4pERVpAyPVnFqCAUqEQ7OtQaoVC8Lit+0IQrAeETVZT2GMt UuB3vgNsf5QIcyFMG1Kp4FOSPKQtt1q9htSG7vlLWHqOex4WAdtJcAm1bN2hMf2b9HnwbO6AXvDp GY5ChkaMDTbjp9QTO8NrCmwIolk7S4Du17emLGAEh3SSMSvZoCZow8LVxnlLd/SC8PoAGGptmtWW rLdDIzDRVUfVphPSWcfx3HDwTGU8Sx5CjBU9YNn1arpIRSuDMt4LSYVrtnyZxyC/3pAzBQnLE5gd 9waMvqIT5Pod8jmw7DQviSd0G/3rQMcH5lm1cij25gdtbtLQB9rYJwzpTZsj8gfa3IDpgOz/rw1/ 3aDc6fvzfXN7vovu1sMFTPNKnUsnfwOWDTnS4XmD0x9yxGws5L8IlgAAEPlJREFUaN7tW2eDLFUR xZmhb9M9/W5gCboLrIKKAQUUxYSigAGzYsCcARNmzFkxpz/srVN1qu6873xj3r7dng431K06VXXq 9jXXPP95bj8v2O32h91+v9/t+5H8xj89ZX/3B/lvN+wO+NoP5HL/q7fs/KYDvuEp3K8t7tDK7lp0 upumNE/TNKf+03/pZ55S/96/4qxcT/ZHfnAkl2f50i+lCT8J9/cLcmXC1SRt4WDGEwd0usfNOI0G Jm0aX/QRPCl/pS/tTp7HuHBJ+poTj5KMUsaqs8GYdUhyw85mykFOs84uWWvJumc/mIF3g4/ektj7 rDPTp23E1lZSGU17nekMySX9I30mdKwjTcn6SSr7ZPfyu4mPq6J32BhUAOx/0tXiTNEy71PJ63wh X8oNIpu55BDOrELQx7FCky2zduddYwF1QDZTjPW6ZVmX47Yt/e/WD9d13Y79cOt/tqWf7yfWfq1f WZZNftZ+Vo6P8nvFg/J10/Nyuv9dj9txRavL8YqMetKZHjDINZdcSsnxp//UflhrP5FrLfKPF0uV ++SLPoHT8i/nVjO+NZxqeKTixmVY0x0UfZHm2Vbut0mf0l1u8nyWT/HGC27Rj3WmhzibMeCKL9of hr9CrXZUpP5Ziw4Q19G8TTX7/Cq67s0071vONTmH2yvaxoDtU4u1JIdHKMfOwWGalhi0tl84/MIp Yx5yqLLOxbv2e2yalVOWAVSeW6DlDg79n4g326AoN1s1/53jggsT42ulxhD1DvumQ1NhLbBVmymU +VhsRNmEoQe2kHYeK6va5UPKNicfDjrEgJqdb6ojC4x1sFNRJD4eOmEqCIH3n8pxqLgrOm95EAYX W2Wdq49FTq5iJvOea9pVaeMaqkFIy/V06DzMWFCKrVJTaqYe2OKaMVWTcc4rQHbna9o7RWMQn+nR oMTaVNWRVxe4aRPbLr4cfZXlXjyQCy1tAcSxU9GkJY/y4JAxlWqTrFQhUx5rjfaqIIJr2c/wBtVe AUSKV0BxpaXrwvu6lNAijKrK8NlomLVPJ9O8zcSyK1ndgLc+0z6E1U2uqvE4vmVOteTq2u3tq3go w1J8RJSZzbwPdoU/Ohj2JlOkFrbefORVldc6t4XLI3ZQ4+OyWYIbnYL3Ahg08UpIkFaqjUxHOuFa jqjW0byarpr+OFy6DAjSpky+un2mwNuDdSqqvMQCij02jqBPun83tC1cL0O2RmeTQ0d1lID7XFum 3faDDW6fXkac8pp9mYAJ9UTUFBJ1o+WT5ht9CazIXIOaUwVSosFlDtd2gLdf3BZUti5tHhXrPq4V nz5RPryf6Y6fk7MrAouIBvuaUgMIaJmWT1O8qs2qKNToYRT1S6WbOm0OgI/w0maKoOZ4GjeEAw6N Yafm96pBcM50T2ZUUH23Xb0mTR0F402RDgiGt7C6MNIIEqrZYHaoaDm6Gjxi1uAmO1hW174VId1+ cOKbwmeEHoZr2fSZhqNCpTlls4YTUKKRlnAyaHxB6LzjTPtn5fSgmdndMCSdr1pUXwQHCfcu8RSO m8laBrkh8L4qXHFfYQNsI4qZ94l1N4c6YFFAVB1xUI2pz3pFQrBzROrYW2FS4yQ1OKxUZgcPd/EB s9ZzHr5ROtXtfZslSNq7yciaqvuophv6jIBZHYQpnbUSV210mSGY4mFlwHoSOHTXNjsiHZCXLBb8 GJwUjzTdWEcJDtFJDTFEvOCyGcJjCbY9a9tDk5dKBKshI9c9h3FHdXU75lsNLTI1YISscJHHERxk eaG9NTAv2jJxUUMUiNzDcFZYu1o9aB7iUa4pvMwg3lm098RdZIb0DF0Zv1DHXLPM7xcXpq03Frq5 r8eaikP1rE20t4+zeuJRGeEaGJqx0zHXWNiTcMj8scPKiRa0JYXJ7JFAHc3VKoiZ2Dx1iEjHRk/z G4VgNhaOqYbWyQ0LxOvg0L9sgwcN2K8E65y5lnBX1bMem+/1Z/jcQINT1YINEVEyZprCiff81BC6 DmBms+hfbrzp5ptfeNONLxoGUyzghE9rZ8qLnFPF2ClEb1YD7A3A70Z7JPTQeZ2onxEKF7bCY8Cn g70FBMB0Tmfm5mkxHtKKKVLFg1iMJcUFK8aIKDReiYjpwldQ8w6JQ9REzpRcOa8lYrRKKDIJboC+ vaf/SVybKWHLDG4CX4zYuCjm5jSdqdk93C3K7JzraJt7BsY28n8DW+VrivSfPre4hBlzlAIVmGWm 1b1XHjA/nyk7c07/wtkOvg/RoIuX2Bue0cBNrVXOGXlF8coK2F0VfqvcOoMIOg8HMGCbZXaKvQ4O c0KEP0RFhnz0/sZ+3YbE32CeuYcoQp8pFuwyD84/D6m8NLNA2UZE2goxNYJPD1eKEo3pwsbEPI4O uyuSUmaXtBMjWMIL52whqIsXXmZIgLPnx1kTHGXDIN5MaFSltJDtVkx0vqTW1xhepfNZkZ/uBxhc PO4ggYSIVoPZouRfunCWyCN4CyHPdNHPOSsVQo0l6r+XMWsDPaomkxvNOpx/NjtNpki04Be/5PY7 Xvqyl9/5CmnzTOHjsrqrGtIcC/RXsIieFPf21oDq0RFadAlw6J3SvdTyytudEH7Vq2sBDHY7DeQu gdVNZXMETXtw7UXWZrkMg9liwboMVqnV+YKx4V2vea3xn+Iir9wNRerH9zCPHKNmOtgFhNVJYOax Xnabx1SRDxrfemHme+/rYEFGePfP629J4IkvLVx1M6dgpElRJFI6e5DZW8i1GR+YjaLqDxtLfGHA cJ9R7ogp5fd1b1D6+jIPDEx2b6VguAKRmBRLKr6UgT3x4FJdetFOBXshqTeCz3e+Wnq/Ak5/0pkS 9ZXzYkBQFtDvB/enySL8cpIPZcX0IuIFh32Bpb7/TcC8LtA3v+Wtb3vg7e8wrnwS8Rbq65Aj2mS2 KQIzRPhC6Xgwa+pkEb98jFl/EMb7Ti2CTOldDyFkuevhRybj/C9Nug5ng9wkl4kSCRzEEtFdJi8X mY3x8Cred0OH0vye92Zr/X2PaJ0i3UP3GeBmgZuFK2nwp8KCitybx76aI0gSIc1ajedC7nn0OjXa 9z9K/S7tA6ZYl0Ns7R7SqdchP92jyLMUY/PKEHmquot4tRJzIS190AosHwpKpZUPa1HiskR/5iXV 70s0sqHgEuGK0nRD5DkAqxxogaTDYAeXj2gl5KMfC3qnlI+rLp/LDXQXDgxmPds8cvhYU6IeocGi TV210Yk/pqWtT9CuQO+caSXq0l0oXQ3BuIPhNsS9IDqmJZKE8G2FmaiWp6bb5PFPoq6TPgV+iAG/ BmbiZcZMC305MbGhjkXxSnvrEM/SFVp01ieslalJtDd/WstOj0cK1U/eoqXHezxGGsIkZsvo1NMK UYKjMcaWV/DJpkIyvBNFqp/R2tlnzSCzxb2od51b2lU9dTMPXHWmaRpLmZL+lzBrz1F1HM2Kg9Jp u1OriXfc6+lNH+WZBM+AQfOjwiZ4PoIzDSYzj15mIW+bo1zhYi5WTr0Q7f8cBjBPn48EPOcvaIn0 0khMp5g9z9RosEvMGbMJqSKZN431AwMbxKtpRT/3Ra0yTl9SiXQX3W99TI33MgpWDuIVfisLhz85 pYOkeD763IJIr06Jzyhopguc+DImOqevONaVr05aRL70DMvzGSvUIa0IL7OHsm85CnbuFxhe5RmN agiav2Yxw9e/QeQ5e8Jc+pOPKgeAobewQBxpBYox0oxMPLJf1pncfipdG8Zw/VNWap6/+YCo6re+ /Qjq5XLHd77LSFDtYKQlNtxDRUJVMcddQT4QYCDeNF/oxae1at6N5Hvf/8HjP7wuWYVcxvKj4ozJ kB/DlhENRn4KGKx0aYzQyNMjBEU3Fyr3e39sewh0ewGw+CfqZqZnBp125df2tNZ28JlK5EA0qjFA 50ksMHnQako//Rm3EWDHQP/9819YMf6XwQrQFrIxERuks/cYiYAf4REZAwV+nZHMVBHtV79mwV/L 9Je/yb/V6v0zNlEvNegyiQ2Cwx9rbWljSOMZeGYeVw0ckidQrfzu938AZKsI/vhQLn8CyKU/u7K6 qIjpqMuwU6zKQiaQNRaVisWizz717FNPPPHUX7yNUh64b1Mn++Rfb8CM/vZ3WeO7LWB3zqEikJVi CZjteaB0po3Ld8LAacnb6+Sa4JKlK//458NP/+vf92ekxbn9579n/7u+OkdTWHwwhbJiUJDM87zV PFIi5mosueDkyS8NCU/ogGEZHeiJfLOmimIzjHtlvVZyJmpTXhi1ooG7dGO3a1DvLN0qKVCtrGih DPNcRPgDu0I7JfY59UAPPBRogk8lacIgOTuFk/0czcX835YiVdyjArVZruVRqruIOrDYDGk9084B XSUPll4jaGA8KEXblNJYP928sFvYaOBm7Guoo0mRfbb1tHCzGgPipCqjkGUegu1Zy9O2WkNpxBUm O3mQi4ubxa7x5kqTqkZ0G77B+tSJB52eJK2oEZMPEbMvz0hXkTHNykxYjFOj/kgjRcSoT9YFO5kG RUJ5uvh/Z3yJoPK7kdrOZEHL8Ej4Cifv6mhcwvfOvqYHoOgSi+S2Bya7tjBM5z6QgpIbYCjH/QHh FMWoKuE0Y01np3SkaGv0cfEdLqYgrXlUaEWX4ivanGErYZFM+7wIRyPa4HGjaDsJyUyqKgzFzTLE WN1iTsjmQQGjoDTWpPq5VfqZqb2CiUpI0uN6xOW0UmFjAyAU78tGWAe6qnIzQWGRcYVP4paDiTFS kPcUWVQBiAuVLt6xpLbAB9FS8fQ1ig5ssx5P9g2i0+wT0iGfKL5HPFVdisGU7dbJxcrFA3IZne0K 1Qe7AYWCkBQvA33Mw74bRxzbSVNaKKoDhPv+FlbEU3XUBzjxkZCcJyWZsWqNMxgJkkxaqDFuVxUY i0CEkeZckvevISjoHw+2k2XiUToKYfvOlOp26BVvd5vuNQcfUKutFEOCFYl17NKZ53UQKnG6DuoS BFiL8j9wqhD9xijF7dwTjJaPKXikvSbFmdhRyD1lunwXaMxz6Nb44av2KDi+VHd52OdAO0Vuv1ZS Vi0T0khkEXEDAqDfJ17JbJr1MDi4AT/R6WAyVrS1NWrhtrhjilKPbXSG6R7HENk1tGkusWqbfrTj ZY4KFOLeefX7nHHSBWqu1hTq6OfJ+RscjlSQB2wmXmXM3LWJ+azu4iPeDP9Gf22r22ihtkM156GI OWzFZC1SB6pFW98LqhtQY3tCpSKyDFOY2HqMx0KfTzww4QQRfCda1o1tJ/XTo9c5B50fDIi75Kqt t4doZhiO6yOU6almM1hSMGbA3rQOI87OdcWMh8jJC53aY/NR+k4lJ7Y5CjBDx4HvBdExb27VDiGO 1UWH63UWZ2A4EDcU9xBDYFU5ZS0cDOKdr8iO6G1ZjqvsfZbN07JdetOd0gu2TssGadk8jY3TxxVf 7KYVz/Rv8sBRNk9j07T8lz+6vfrKFOXp/Wx7+5nD635+2++e7OhkH7wSvnZJN6Nzy7wWEpAISuyH 5HlGemtFwoFO125SspcDtBW0bBvLcSlxB7y+BJCMSJsTXwngZnvb165Uv71PYPvY6WWY22Jv/Ozp 9QwRaLGb85rtnQbdK29b6/11hsTXGWwHPwUw2YZ5mZyHK5Ptkbdd97OLOJkM7P0Hf/dCX2uwiSd/ KYEvYXBW/pqGvsKAUTJy8NcFZkgfjcx8Y4Bb/b0OY/PE+K56I2JWUcUrApO+ZmEvXWDsOtNrd3gH Zaevo9hLJzu8hHLY29ssB31LZXeQu/B357f62yt41+Vw0JdUdtrqvn8/WEt4EWavr648/3nuPv8H 6E2v1VYG0PAAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjMtMDUtMjVUMDk6MDU6NDgrMDA6MDBzEoro AAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIzLTA1LTI1VDA5OjA1OjQ4KzAwOjAwAk8yVAAAACh0RVh0 ZGF0ZTp0aW1lc3RhbXAAMjAyMy0wNS0yNVQwOTowNTo0OSswMDowMPMtGD8AAAAZdEVYdFNvZnR3 YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAAAAElFTkSuQmCC"/></svg>',
    name: 'Indesign',
    value: 'INDD',
  },
  {
    images: '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="116px" height="118px" viewBox="0 0 116 118" enable-background="new 0 0 116 118" xml:space="preserve">  <image id="image0" width="116" height="118" x="0" y="0" href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHQAAAB2CAYAAAAZUrcsAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAABmJLR0QA/wD/AP+gvaeTAAAC N3pUWHRSYXcgcHJvZmlsZSB0eXBlIHhtcAAAOI2VVVGy2zAI/OcUPYIMCKTj2Jb115l+9vhdpJfE SdzXNJ5JZEDssiCFfv/8RT/i4yWR7NK9eLLFxDbLrpyMLZtbtUMa89G3bevMsFfTsGSXrE2SNk8q iC1WSYuvjo1ZfNUjq+EXCUWwiVm6HJxk9yKrF8NGawFmC6d4t90Ol/BRIICNWg8esk7HPXwweaSB bYsdet/BKRdtOREHue7DJJkPEW7gk2QRoArqhW0RlRxr2HZYefiZO37ntxG3EbaOwBUhzunl4a/y GCwQk1lV7aU0puGM8oorniQryuk+Pnw4ovgYjB3Ii9R47kwY320CgJGLoz+hiBeUBYTwP7MABbQK jWCrQ6kKhRBx89tCEKw7hA1WU9hzL0Lgd74D7Hi0CGshLBtKKeCTgjykTbdevabUhun5S1p6znud FgnbRXJxzTG6Q2P6N+nr5DHcDr0Q0yMduQyNGBvyzB9ST+xIryFwRhKN3uUA6La/DWUCIwREkIxV igHNgjFMXPI4bxGOWRCuD4Ch1qrRbYl+GzQCE606ujaDUE4dx3ON6VYcQmEFvhSs6pzvsOsCG94U oZoJbkwzTIuIshRMrb4hRwniOU5gTNwbMOaKLpDrd8jXwHLQvCSe0POYXwM6XrCOrqVTs1c7aXOT hj7Qxj5hSG/anJE/0OYGTCdk/39t+OsG5U7fn+9b2PNddLeeLmCaV+p0XfwN5BjIUQ7PG5z+AHdl bDTb/vsoAAAi30lEQVR42u19fax9aVXes/Y5955zZhyQj4FxJtQZQ0pqUrRQC0i1VYHWgB0oVFva aFMbmmJRxELsaDokrVhbamI/okyDWqSNIgkfUWJsCbFY7WCh9iOFGRvGGQdKYBinHfidc++596z+ cc7e73qetd5zJ2mTtmT2ZH73nL3fj/Wuz2et/e59zN3x+PGlcwz/twl4/Pg/ezwu0C+xYz5+uLRn /C0AzzMYmhN2AAY7fAIQPrcz8XpsE9vuxx3/tv58fuw19m3fee7ePP1jHIVp6K2pNxuve1zXOC6m b9U8HkayxJc4n/IiygJpPIMBdw/+wI+SQA/CvJ0nskDa/pNPDLfu8r0Q4EhgzfhMuEtLZrrRJ0/M alfG7x7mYZEoo0zm408QYbCoGn94DQZWKUibSGueNys1n48jksvliTLRRvrYpmbWs+BYMA7IIp3E HRceP1f+IIqX2zY6QedYNZqQsx2qOrVzKoxRHHnGLAimYxyN15i/cc8mbCvnGVBOhIIhINbnoXQk VoFMRO7jQQ16f9uozZLa36bhlUhqRvlEbxuzpjMyexQiqxfCWJAz3lEyp5VkobbPWaW0TQcUsfuM Zq4RyyZCNcayiKyrZ1FQ/bgFGpXFE0XnYM03RCs0adeUgN0du/bo4psga8/D8wFZjZ14x22v8jp5 vsyzoRoqh99obbwQk/Ya3nly9f5RcI5oJdyv9fDpvza/uiIrRmel0aOK7Vm5YjxmDMEWr1E1qiJb JZLY2L+4jBIpyXICAijqheAdgM9hnhZcWUqcpBIyUp8e64636Y1lxblaPDVFWSk9KUf2UTXS1vMV v9hfeVdI43EjdhgocmeOzXWC6O0NwGcxw8uXp7JYkx45eTlGWNNw1vGe0tTn+WoETVUY0DYVrS7j c8BQd6g2nzFzb34WQaYhu/T98d7NOW7CpfCMOT1ALqu3bi4hRzwWnOOYlakDZYDPc/UsNFLJjrf1 U09R56gB4U4XK1vMR2O2F71qq1c8qxhFLbnyDI0vnPuqcpagSAVWt9HpGN+qcDVnS9HY8wKV1Yps 4cwM9TFstRXtDguDMabmmKfoOUe3iAFGhcrzGolGkAkxlSN+VKFj8glpC0/LgbhOwePkTn/zYhjK a2/ALBOXoZSAqjDgZI1BMWhN3isf8Fya/isXjv1F6KEFj9ZOcXkQnFXj9e2+SrME5cYuza4c2Z2W wMTZ9em1Y31L4r2+XoGPiemWzzsxqwY58bwV53p0xIRMs8QKyVZ5dA5HBS8qfh/+jX2HPAwvNDHP 6wkNzcpKt2rC4HKhMq9V8TSDfHVLPYClLtMLNk40OvfNo6kfU/5VmW/2Cb3YyiNa6pdXlgQ6ao1J sxb8R9dYBXqd6ior7Fl8z4ImjRDGIzBfqzNxvJ7W59BwOG+aL7LHUl/j5bhZaEARzJxxQsVTzge4 XelyK5jPmpMZqYyPwqlBUxaSh7/NarhOMuVpRczcMz8zTCmLdDEj6tieKzqMbEeYVMU7o3ktzMvo e+KKFSEKWV2ydWffUMRQD/8dFqQWEEboAZljTMvuLzJdc742ruaJcazG+Ow1rGR7u3oMH2Sm8Xo4 t63Ts9Yr98tKoTfT9C/fltOVFWmLZoPNMibtMqOWGgeUPI1JERhoSjPdZovBF03T48J6wvCCBhYu 39arcmb1WJz/Zo5paQ7FmPG7fuZbZ3nuCKOy++0IlJPXNpASoEzQFNirs6bW0sj3MN94rSlRnQnn eE3RtrA0FS5jA3TaR0ojY7vAENHGamxgxRy6uExL//5RPOY8zljsru4RZvSaY+JBGEIAx5AcK+IY Bmaei9Aj477KgJt3wJk57rUBj3h2V0g01FihSoXadysVoRcaYpjpudaMzINrDg17HqghbDacOXfN KcH4rfb/mobn9uxudAdBYJZXC+GdD+M832SGv7E+xy24oPYfGhb4Z8sB9+2yICpBVZTH9UU3mzEA +yEvrvEYRYrmIKCnNNT0Rrpzi6EaSHM09yycqngA1JZhRYvoesccVvswkNjP9p07x4+ur+EWbKGq 9S27M7zj2gavdNDYcV01TfmocsKeN+kJVr/rePs1c1rVO/qgkFdDOxYYFofIZGq/cWC+ex+F0Etx dKlTuw56HkHVywB8z/mGFhJpdjhO4Hjj2TW8eqdMMFgxNsIoGR3XeasdQFuPJ73clvkW6ZZzrhzq ec48yxCH5RtnXgzAoKCG1fsPUUB1vC3YK2jaw3xPGQxv2JyNmFmWFFvuP73ufI3ngC294Flgae3e xnImt/ZD+siOuOeiVZCZB7lhVXZkg2uRt4tyOZfrO6UKdlNqcFhZVVeNUKLS5F6s+vad4zrsoL6k FxUNwA9utpgZj6oIOP8VVpuOXp6ecEG1r6OmtGdrDCmjQ46lDcYvrXd3o3WVDzE5Wnxml1bdPVGk WWuyJQUADH/q7JwWENEmF+QaHX8AW7zY63mYOYwc4/d+nh37GZ3JOWReP9I8XKTk3JfH4hIGr+zI zvl9hxwTclpS5UlVisOM6eVz2TXeZI6bcEGtx/4PYo77DmC9ipF/drNN9swh4Fj5LtLG4MXJMvg+ qPb0cl7lFQeT1p751MMFhUAFdRZujQVY1VtVIw1q6dkqqh2zXCG51duomv+9a3mC169OscEQFtuo +cPY4ukSm/UzhMaxr8bZiVJv6+PevNOgupdaYQ+lx4o+2UHHDeylQHnqalIrW+TrzITDwr214e0j CnNUSRxf7qxkUVHuMcNn3PGe+SL0be7LYHjejh0Vu9J6y6UidcpprbXh9R47qr3EOaHLKuJFK+1R pC3R4jKLq1KUtPBj7sAhyn100XwzwHA9ouC5PnLt0PZXTgZi8egJHI5nn18mBkYh9TxNecPe+5bN aVw7pwYw0RgK3MfyYg53FaQrQVEEG7F0zjGg0qIRSEZLjGrBFpAzyImBo9uyOJ/j2lBp8/7qlx0Y +Dvu+P1pOdGxG57ll0JJY6jGJ3JtVtBvKkB1hwa2ao67tArTcbhvzo9z5UuPlLZEQT2Wwngj5aDt BRNUENGV8IMTtdI8Ytad8+bDfDsA9+K0mNVxCy7L2KVI3Iq5o0VW8bCaL661Xc0uPyKDGPvJol1V MeYIOZ8tb5+pi4gARclutdm8LTMzoap4RCBRbyF9cMeMicDomRet/wOzOGObeYUdbjClAMV3dcnc oI1QO8hoXZlS74i9AS5PYznl8pzWaK4hAuXSXSZcLVbBg7ouHWHq73U+2kbjMRzApwCcgwv+IwO+ dnsx9frsPAotst9w/WHuXvLvnXwVYCGhwwNu33b95TSkFipbZxtfPde4op73lNJfFpouPOdoLf+q 8kpmBmDGqQxbvpFijeNcAvgE5tM88XgWLvDEQ59HjW/9RSR9/T7IJwHEeKmrYkTcnCIrVuiqgMlr Aeka9BESzdtZEXIEj3Mcdbm1Reqk1Q52vcmdn9qavhfpTJWzfnQeb93Gh5WAbzjMHEsPkDGu61gf yvZeMnjkTmZl84tEu1WJhXKZ/60KD1VP67QtCgtq2pVFZtTJ4mtsMRpLb2f5YdHeEUQb6yMnTYCt xf7bt2wuwcvKSf5JKAZUXkc/91xvbxtoLTRdS459Sks1p+bWrPhs850tKMcGjtbUPzhWjKApb/eo AFdFz3/cAY9gJpB+v5jn4ww3Hhq3sbhc+QVBkuPHFEuLFRipJacVKmSUY7FHq3isIaoqMDC2qdQw PZJf1z44PtbBu03MC1BsrKTUMYXhvMHgBnxoOBE62wwvu3SceLQcP6qgY06Zz7OfoaIC0ZqfJ4g5 tiqpnsm5RJZDpr9SPW4hFsqiqQBKBZDyObXPnIulfK/jgiJD37eYlYsAgFeen+GpO6YiFkquCVpQ NB3nKrLBwkXXhQ7+puLPOWqkJ+fsChxrFN8VqOpblULEiYA93B9dl1qxH67H9CTH5L7CKEC6xx2/ gxmawrXjKdjh9vOzrkV+fpfdoiLwmFtrDM58OO4BqrVpRvBYj5zauZztxNDHIszE/EB15Toj5RVI UJdLiuG573uXpwAxpkW1p2JXOEfDGQZsCsGN364CQCyQPl84V4zcbL005dFWVszH11RNeAZ6FKKy MkV9Xpy7CqnF4yrgRa7EONY4gF8G8Eio2dZ7YNlFPYShXI+WHWNqpe1i/tlDsyyEKMTMOwBU/K9S F+UMG1W9R6rc9afE5CQ7a2Y9BheYK2vkvy1i5trRvt0GwC8ucs32GND6tCxTWZFSqTSWU78cd+Oc Tcm0SADpB+sbQg89x7Eq4Q88QBSi5QGcYbUKVlnsBYv6FRDGk3UdZH/+F23AtQPp9TMlbEkPzJt6 NYr4rV29lCPSobg2ttEN6r08s0a1dYWocsOavKhQiye4eYcOuSNrJNCCvQBOztpVW6ZqfJ0MqWd4 FMC/OD3psKYJaPz24NBS8rgD6Vg+2BNAP2RE9bDEcOuMGXdB5BKgJ2FqWeQoygUNECzU0dVMB2AW y1FGM1WWphhtPFs/qVXtKHD8/GzA7yfEqA5w//99sxzRFKpUa2OmVbmoutt2GzEifEW2bFlto/mx dxczIre0yiTQKYEvCL56uz4DaUttFGplptWJdO+RCsMXd8BPL5fJpbFq7f/e2xEUMzkjRgUdvfyP y3nBJU7Gx8jWi7F50MpTVbRk/5d2LFS+uY55fabEPCYKPCLpqn8mr8Z1+/uEhvcY8MlDXtro5nzt IczwsDcRx6tMrUMtUYWqOTamMZVveSRam8eYWRlRrHk7zaOHplOpOF+5Ql1cGygHbPL1pgvvCS4f bAf5/iLguHDgH0x5qSrC3kI/hSG4PV6LuixlbOUqk4N3p7ajEKoCCorv4z1i5evIs8Y3xssRzB1N W3T66pkQCwP2jt79k8rlcj7GWVl0qZVlfwzAvxqWJXgBgK/BOV5o8Qm2Hr3M0DZ/3s5JPDD1DMcA UPsQkWx8pUBGFdEkqjVyiOvuKdLB29XjYCIBGI+uKIOjuEDO+Y5bzwjWAOCRgm2RET+8XuOp00sw 2OlXMVOp5NCTN2/FVO5YONFYP65XjUPTQV5R5t8VFlo7xCi6ymK04dQmISrOoyKD4vkqv0257uHD 1+/GW9tRm5ur+nLscOf6YgpgGU3rbQkPnytO6OMOh5G8FlrFK80nY588W6ah5AfSRmvesNWLpn3H lRGxi4RzHM23odKYcUHObW4x4BZcFqzhEb4OZ/grhc/Z75rI2h/njiPHAkBbx6G3sY3HnY3lCr3N UO3TyGXENkK8k3TkYSV9hUu1t+Z45UPzwpir6ttUVJujaxn3+GrWGF/gAQAvuKwWXEU0w1892+CF xgobx5zcK1la/axnxQfOnZ3Ol4exQo9hRKFP5dKtI/LOA78KmjtgRv7W0aWNFF9apfGUs7hDXwIc /C6jcXF/8vySvjNcY4c1AHjz+hq+0qJbzTvzWEN6rxZnYbIV1wBJZFl+14erdV3cN/uVtOuvn6bX aQbHwcakyKCoKJx75V9WyIIOuacw8UlmeC7OgrCPR3rHfqf9j6230z5dYqYwp0ptJmo99uHKzTE0 XXsnbcPqGI8IpKp5ivfl1tN0qxuIthVrvxXqY4HH3LUmuM1WMf1PeL7NNX7alS5p//dWbPGW9QXm AV3l1CyXHIkjYsWZH+qNchGhwtfMobrwEJW8m4fWOsUprTI0LmXcqJyJsq6aRFdXzd/X0H37/W6/ DN4Ax99eXofPy7MuUXxfh3P80Pnu0KJmV0VHHTu5bxRe3KVQFTZUMFpUaIi2lwDxkWq5TFh+3Xdv qH18zKisF08UcrMm14oT575xMDwX5zTKqEifwxwfhONNywW2hSMdafrWyzP8NXq5RqNK38ZJ9Dqf 17srnPq0HY8IbXVc5YXi/xxCYrpVoFzV88pPO1izuC+S8GtC4/kKn/LfXjR62cUuxIvWy2D41ycn cAD/FcDfXyy6EckBfNf5Gt81pVSNlfpCSKI7IO0YImpLzQru1Jc5wl7LwmdG0Wz1BcqN7Gv/Mkzq JfzK+CzUDLkri1eF6c01wPBt51saPXqUX503RrzfDO+YL6mdzvzXz67hO+R6BnQVp/LneETLjzlp P79Ub5Zf9pXAmRzzPCC/CaWh0p7/5+DPE2aEOqpIBcWZidwjCvWPwvEV4dcRxjkAwycxxyecKf7J ueGmiyVegjMRQcvw3rBZY7dY4Vdsf/3UgAWARw+A9ovBFmKGPuaOsHZu/z3WqjSrVPHx0c8oGLHr uUKg0bRz50pjrTjf9gRoHTQLTrd2NAblJY1jvfLw6EO8tzNeff/iVBTFMDPHzy0HPHcz4MnYBbrZ Xn/g7Bp+QFYVQ9EGAx7G/sb65zHgwZMB9w8D7h+Ae+FYU+VEkaoToyq+9fhaWWd9s49+t2XftPLd Wv2IzIVMNi6ljpvVLxrk5DiuRue+ZQC+EecBsDVaL2D46GB4gTv+kDuedbbDbbjELbicdvPq3Lq7 XcFHXPEKjptxgZtHqraNRzsAv4sZPnoyx92zAb8F4EzXWBQNIp81frbfLlSflX+2Mwm0AsU8oQAK VwJjTafngqOgmjvOZOHw2KFmZcCf3+7IauKS59jhnetrCShEa45sQklDbMfcUQVi4ThuwyVu217i Vdu9NX8Ip3jPyvCfXTnCvIpCbPTUD2CoEqppya4/R8+Yk4Cs+o20/jFds8ieYz2aooyu+QkwvHQb U5VcAea7J1W1qAmNlSXmfdm/NE8RCykcy6KKLLHDt2KDu9Zr/NTmAs8egtstxBsFGR1+BmnZSccz 5bMtDQjVqUatPzleZqHqq2KKCsw0R9PTGwD8mZ3jxzdbrOCFEvFSme5c1uBEPfuX3F/9SAxEuRCv NeqvxTnuunYNd1zssDTmlVLIRQxPvLoqraP35Y663cNhlXP0ID0Vvotke+hNwYPDcQLgG8zw0vUF no/t9HN6TJtJP112QKIYGWlyFWgxmrewssB6PyvduBfzw7jqkbO3X5zhqy/meP3qFA+5k1pMoxQ8 YwkxfapAZdpSxj45plbGQIcWasyi1i+ygN3f0w14+dZx+8X5hEhVoeqtbEDtGzgWjgzYHpDqQxjw ZXB85fT8d1RqBUzAf8ICT8QON2GHxXQftrXN0ZHHeSa2+Edr4DWrU3zRCwRhbb7GpZa/KiDSlHKu I/Eus+q3QaPTZETLjNfqhl7l67cOwHde2+HFOMMJEAhvbpAtnJmWw8W+5/04wf0w3Hc6w+/NgPth +DSAh0Ntbwngzs2Ab8Z5IQzm0BPgePPqBJ/YAU8fgNtg+OrLSzz73PFHcIFT7CSCR0i5//ersMWb NjPcuRimcfP6mFexcsfeoINyWROrOk4buImf9VEFr/tRq+MZBrx2fXlgZhyR50q5arD98fxnMcNv 2wk+cTLg4zPgHjjWPjQKJkDCJcozAHcsZ3jd5RKv3m7IZyjwug1bvH29xbuHBe5aDPhNd/zmMAAL YGkzPM8MLzu7wB/fnReOuXHhJb7Bvxyuxz07p1YK16oKnLr+2Cq5XI4pQawyegRCmupQFaXUt/29 zO++2OEV2w3m4VqRlQrxfHPtN7DAh5cz/HsDHvRAhzcK2MlrUGlL+8czw32zFd602eAk2Uqbc4Dj 23dneNF6wNsXC7zfgK3tH6T6NXf8m9MZnmErvH59ia/HGcW4OOqrznb4kZMc04/xLVPOLTq/fZY1 qn58vZcoZ3Q2Xh8AfBuAd63XeNV2PSX80UllvWsjxyT7k5jjTasZ3gPg95IzyUpRC5ZX/EsAXrNa 4jOYEdK3RKHjybjEG8+u4V2bc3wHgOsDOHzAgTcsZ/ipk5UApwawnne5TT6wt7GsqrC1NbSWKW1p xeO84REymPatEoKoQ082w1s3F/ihzRo3CJuqKg4vSjewAf9kdYpLUVIVWqSurbGPth3Axx34y6sF Pjy9ao6FoQp/My7x/Zs1PrA+w9/d7PBSOG414Alm+NWZ4YEJo3OG/DRcYhXn91xliz+fqZTw+f0R KkU1DG4T6K/Ks5irIkH0919jwFvWZ3gKLtCcXrZhTiUqEe8/fQQL/FsP9jKGyE7AbiLguBzXH2Pr /3DH31zOcLuv8P1nZ1hih+z8WIUWuMSLscOLNjnFqeZ0+OGl6y0riEtwYNpJqHlCHTzK3z6r8qio m9l+dI+pKsSLDPin6/VBmK2HlgLGb3fj9PBmzSp6OC4w4B+uZmFJgW1lDlffhlI14lrP/nifAX9x tcBvYRE8V4vNkbkxn80Vq6zyv4vT6Ra9qoi66RyG4vVCoLn242miRnaveGdtK4rv2/5pAH9nvZaX iEdSR5YaPoYTfPdyhX+3mOFJk+5yCcxgeOfpEve7IVuZLraiPV/nCnT2NJ/aAd+7HHDHYoWHDm/O VsHzSqpgkmPe+0/nNJsXrbT6pvsYdNXlC5BjxaOKN01gMeIe3HNQpRea4c7NOth8DbU/gxneuFzh tcsTGAzfc7ZJixmZ/iBm+NmhZ+O6GrbI6bNzKa1Ki0gRbH/2gwb8ueUCbztZ4gu0mipLrkZr9ax7 Mce7h1oJ8w4p/suJG18pt6Dogqpjf6cl73sfP3+FAXeu1xiI7VzqMgDvmi3wF5an+DCApxjwY5sN 5ocKkcY4APiR1QKbNFt11IXARntmVJ2C8VxrAD8zM7xieR1+crHCZzEL1/Ux/zr5+A84xfeuTnA+ Ah6vvUcMfxnx1z/JQvdD9Q6cCpmZ2wfcDuAH1zvcgB20ZD/2ehSGN69W+I1D+esGM/z4upX7uDix //tz8xU+Rm+hZoAW6VShRMiv7XrOtvJQ49ofheOfG/DO5SleYAu85OwSL9id4waih0t1n8Ec71ie 4r0OuBvGm/jjrwmrc67vK6uIWW06lSJFVVr18XLYkZDnGvD8sAG6jbvv/SnM8IbVKe4/CGcJ4O+t t/iD2IbWDMDuxQneNreJyxrB4gr6N9j76Urv4JIGpxWG/Y3tX3fHr58OmGGJZw6GZ+52eLIDT3Jg 7YaHB+C/DIZ7D5V3t5z60DzOeb9iZV4bq1wSaG+vii5cbxvFVi9f79I4Y5uHMeB1qwU+fRDmyoC3 ri/xHGyhtj/O8SiAO647wcUBJ+XkwQD3KQxcJSR1wwotKmzNNxGU2ftrOxju2TnuPWicW5grpFig +fKNbhgrDs+Zt3FHWXVeDae/fqvhGPSvWsMfw3Zy2m1f6r73Hasl/vthcTcb8Pb1OZ5D4D2Ove/5 w8sVHtz10qLDv9YXYlVx0fja+wsRZpVaNMTey8UjHVouZQ4zutUYGnGwUrY/yi0omCZmK82QP/v+ Gw14Ir2irY3ya1jgt90xN+AVO8NrN2vEwlhMTsbF/sRiiY8kKpr1V7sRKyvXtlPgCO4t99XIX9ct slKruPXIOwJrVFLzW3t3QVFmy1WuKVdanlDAkmlac3zfxQ7fdHFx+OmrDGciiPjZ0yV+QV7+H/e3 Vjloa83eRe/8TH2Nqa0UQvv3D02Aai8AGUt5y4CwBmc5EIhAa/Rk0r0HQxqRjworolv5Rj9H+1Fe Lf/xdsx3nyxx19B7c+Vx4ANhRIVoOQ3oi8nd04/Vtn24OqZ3hNNoVuHr7MoNp0Fyf/Wj8vRZDtmV rzbpETXwc7t9StKmr6ITX1Gr+pnTJd46M9mvENvWe5PqtnXO6dP/QeU8OsPDug1ZqWQyHbNXLFDv 9ljB2T6tqZ5kycqY3sYZyWpMY0DQs1bDHtl9IPwOmQmp8akqJXwLw1sWK7xtqBF2ZlyxodGRxi1k MPUlxQjoUl26l+NZGhNpnqz4VZsqq28zcLwdKVLgRALN2xlrBBsRmC5ubPPTJ/v9OtnnRzTIy38A c7xmtcL7jGmoBMvfjObWR/YnhrkiVE9C4ltV2Yuoi40Oj+FhRasKSa+Y9OUCSgONDNXUO5HLzY88 ZCAeXZXJ93Gc/+nA962WoSwWHXckGfgiBtx1usBfWp7g496u5GwrukVmal584YaNLTwydrIiA80Z aY7u1OMgI4gTz1C73sjf6BM98VM5lXG2F9ckbeF7+pExxf1O37tXZmEj7L+549WrU7z6wvHN2wvc iu1EwgUMH8cJPric4wNmeDSYRoxZTuNmwcS5Y2rSQ4YanyoB55y1A75MbMXyfFUuq3l872hKzKNW OxLj9ZC2cJxj/KT10rF8FSf3xMQvOHDXzHDX7ATX2QluhOEMjs8DuPBDPw+3uUlBqrhXMFZgmYKL q1KN1p5/JAg0TgVfasHhSKs6hclr5SpcFh/PwTPNcwN2DZqfjZNE+N6uM1OigNcO3C/XKqb03FS/ Td7fmwXSZ7zOk+Nki1ZxO7cKgmNd7RkqerSEGv1RpULc5gjKRUkmMyK6gREVGtg1KFTKiXpfkNU9 zIhcNQ1hhWNdrvPXHiCpkSgLq7e51YjJRmMqwLREt3q/ik9q6boroiNQTSRUQByK80R58ih8bWOF 0jg6NmS1VaMcRzE0I8tMS95pXK3lKprr3LC/Kk2ZNA1ThcxAreZV511/ORBHohnlFVmSx7SgnrhX tqsKAJGqyiVXYAad8eN6QP287F35ql5sj5lBVuyr4yHPa8LPyGnlYxtRXmsT32ke4TrnWwByOayg TpmsrrcGH/l6E4Id0dwsmthK3XOtHH1Fs3SGadSUI9upzpN5xBvLAvUW3bfJ7B2XGxdbEd67z9gj Dkfa6TgKtup8zMu+LDbGpDFT4+c3a7CXBVhZw9W0eHf84249Z+l1xnks7Sl/FaIHriuEVjG1XwLL TNXnUCvliALXsSJr837hPqPjXFkp8+MJlYXxixZ5fVGI7O9q6loszUFK/YHaaSlQhv65oJXdZwZN jemPDUxVcYXjG4/OysDFSk6rcgRVK+WtoZBPoZggCJuEZU2MnHhkG47Apwv+CgFpmND1qWzSz00y QfJOgQiEPJMVa6GVlmX9VPFlm4usbONWeDPP23ABj1iNPp5Jvsnke7BedukFOJQ1c2ozWnhTLVWa YyEsz7A/xOVq5VJiQCwihFRimrygIIMWztuiZ4gphDJ+VK5o1Tx+vVQ/ch1yvWJitkw/2qaPxgvk a4yJc36t1W+dM+/EKEBRI38Sr1cu0dKUVezgySHarG5Xb4eJHXq2qkwDb/5Wpsf1Rver17IQHjuK rjmV5z+WUSoQjbPHQKgIv0hbikVbPOfpU1y8p4kLUCFxSUfPdcwD662TExMizFtAokPT9Wlsb4K2 aZJeXtv6eFKMFL6caY9jXqV4KlQunXRcbhZYZHBOI7zowb7/CEQPrrtCulYuy48yNh5Mo27HqoVS 4846zWHrjtfrXQkA6OZ5XlnOaZXGHLry3migs0ksEvk0XOJ9m7bNshKqyfAVANK6Y1WHrHPTDKiq G+THhVPT3nPDOic652uEbyXtV/XvWWCk4Wm4RM+skkDHJETzqgHA03ERgu+xSmK8J2mlEMdxq7EU 41bPWGrrnpvjhCuLSGvMLb7blYKoaanX0FMvTuWOqRbQV9HsdIvnQ9u3/C+zydKQChwUM2dGxrHq 5F6dTcaQinnZYzii8HMdlx1y7tWu1yBHaVFaPc3F4x3D6cdwtxf8L96xMNpNTrZ5mU1Qff2tc704 DgukcuVsf55aKONbTpcjUtvqEX/3JK9aY3Ccq1qTOue+9fXQhZWii+qlvKhmFoH201gt2LdlceKv +lnjQy5AZyvpPdORl6yW3cao4yw/ARtTs5gVV2WByFij8SvqVJgsiL7iV+lQbMEj1hWn8kcEWP7V TZ/IDHYxOQF3qK5H4iISjXdUqoXFHLeCBT1XrW6YbVP9A7+lK853TD1yysaibz5AuRANpo7JSEoX 6eu8Gs7hd0cL4qky2FHG5bKBvg27ipas1QqOalCi6Ud+PtwD+yINXFUZv7cZdJN1tLTM/OhLagxh 1MMDLZxFqgfTdTG9mjAaHLh7GuHYzwQ/fvz/dwz/+0M8fvy/dDwu0C+x438Bfu1jxS4TcPkAAAAl dEVYdGRhdGU6Y3JlYXRlADIwMjMtMDUtMjVUMDk6MDY6MzkrMDA6MDA0lzNGAAAAJXRFWHRkYXRl Om1vZGlmeQAyMDIzLTA1LTI1VDA5OjA2OjM5KzAwOjAwRcqL+gAAACh0RVh0ZGF0ZTp0aW1lc3Rh bXAAMjAyMy0wNS0yNVQwOTowNjozOSswMDowMBLfqiUAAAAZdEVYdFNvZnR3YXJlAEFkb2JlIElt YWdlUmVhZHlxyWU8AAAAAElFTkSuQmCC"/></svg>',
    name: 'PDF',
    value: 'PDF',
  }
]
